
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("igBnm", function(module, exports) {
/**
 * @generated SignedSource<<4b741462f8ee5fb36a679359dd56c7cf>>
 * @relayHash c5d2ac4a1537d7803281195f96d80c46
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e3b72497ed539c6ef0e7585f8487e809a8f4bf421d724bf0347df59de7511f4
const $66fb75d742ae697c$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "homePagesDisplayView"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useHomeViewsUserPreferencesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useHomeViewsUserPreferencesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c5d2ac4a1537d7803281195f96d80c46",
            "id": "8e3b72497ed539c6ef0e7585f8487e809a8f4bf421d724bf0347df59de7511f4",
            "metadata": {},
            "name": "useHomeViewsUserPreferencesQuery",
            "operationKind": "query",
            "text": "query useHomeViewsUserPreferencesQuery{userPreferences{homePagesDisplayView}}"
        }
    };
}();
$66fb75d742ae697c$var$node.hash = "a460b0b4084b80e4445d972d6b5860d1";
var $66fb75d742ae697c$export$2e2bcd8739ae039 = $66fb75d742ae697c$var$node;
module.exports["default"] = $66fb75d742ae697c$export$2e2bcd8739ae039;

});

parcelRegister("AXitC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7tW57 = parcelRequire("7tW57");

const $e95f65381b50496d$export$ab112bfcbe68934f = (0, $42omo.createContext)({
    id: '',
    title: {
        text: '',
        emoji: ''
    },
    type: 'page',
    subType: null,
    status: undefined,
    createdBy: {
        displayName: '',
        profilePicture: '',
        accountId: ''
    },
    ownedBy: {
        displayName: '',
        profilePicture: '',
        accountId: ''
    },
    space: {
        spaceKey: '',
        name: ''
    },
    lastAction: {
        when: '',
        action: 'visited'
    },
    editorVersion: '',
    isStarred: false,
    links: {
        webui: '',
        editui: ''
    },
    history: {
        ownedBy: {
            displayName: ''
        }
    },
    creatorId: '',
    likesCount: 0,
    commentsCount: 0,
    setIsMenuOpen: ()=>{},
    isMenuOpen: false,
    setSelectedMenuItems: ()=>{},
    selectedMenuItems: {
        [(0, $7tW57.QuickActionsEnum).ShareButton]: false,
        [(0, $7tW57.QuickActionsEnum).WatchButton]: false
    },
    appearance: 'grid',
    isViewed: false,
    setIsViewed: ()=>{},
    smallCard: false
});
module.exports["PageCardContext"] = $e95f65381b50496d$export$ab112bfcbe68934f;

});

parcelRegister("dDr80", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dYA5q = parcelRequire("dYA5q");


var $AXitC = parcelRequire("AXitC");

const $e6de9c0e17433620$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isMenuOpen: isMenuOpen, isFolderHoverCard: isFolderHoverCard, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19itia51 _2rko1mok _kqswh2mm _bfhkvuon",
            __cmplp.isMenuOpen ? "_14iykb7n" : "_14iyidpf",
            !__cmplp.isFolderHoverCard && "_1qamtlke _1pjhtlke _d0altlke _17zqt94y _km9nt94y _1soat94y _180dt7xp _1u6lt7xp _1dbzt7xp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e6de9c0e17433620$export$70b207c5186d7ade = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { StyledCard: t1, children: children, isHoverPageCard: isHoverPageCard, isListitem: isListitem, onClick: onClick } = t0;
    const StyledCard = t1 === undefined ? $e6de9c0e17433620$export$60332b2344f7fe41 : t1;
    const { isMenuOpen: isMenuOpen, setIsViewed: setIsViewed, type: type, subType: subType, status: status } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const styledCardRef = (0, $42omo.useRef)(null);
    let t2;
    if ($[0] !== setIsViewed) {
        t2 = ()=>{
            setIsViewed(true);
        };
        $[0] = setIsViewed;
        $[1] = t2;
    } else t2 = $[1];
    const handleMouseEnter = t2;
    const isFolderHoverCard = isHoverPageCard && type === "folder";
    const isLivePage = subType === "live" && status !== "archived";
    let t3;
    if ($[2] !== isFolderHoverCard || $[3] !== onClick) {
        t3 = (e)=>{
            onClick?.();
            isFolderHoverCard && e.stopPropagation();
        };
        $[2] = isFolderHoverCard;
        $[3] = onClick;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = isListitem ? "listitem" : undefined;
    let t5;
    if ($[5] !== children || $[6] !== isLivePage) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dYA5q.LivePagePreloader), {
            isLivePage: isLivePage
        }, children);
        $[5] = children;
        $[6] = isLivePage;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== StyledCard || $[9] !== handleMouseEnter || $[10] !== isFolderHoverCard || $[11] !== isMenuOpen || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(StyledCard, {
            ref: styledCardRef,
            isMenuOpen: isMenuOpen,
            onMouseEnter: handleMouseEnter,
            onFocus: handleMouseEnter,
            isFolderHoverCard: isFolderHoverCard,
            onClick: t3,
            "data-testid": "page-card-card-container",
            role: t4
        }, t5);
        $[8] = StyledCard;
        $[9] = handleMouseEnter;
        $[10] = isFolderHoverCard;
        $[11] = isMenuOpen;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
module.exports["Card"] = $e6de9c0e17433620$export$60332b2344f7fe41;
module.exports["PageCardContainer"] = $e6de9c0e17433620$export$70b207c5186d7ade;

});

parcelRegister("aoeyL", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $bCECL = parcelRequire("bCECL");


var $AXitC = parcelRequire("AXitC");

const $293a049c82938ad0$var$iconBorderStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    height: '32px',
    width: '32px'
});
const $293a049c82938ad0$export$a1ea799cb5c1b499 = ()=>{
    const $ = (0, $frIzR.c)(9);
    const { type: type, title: t0, appearance: appearance, subType: subType } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const { emoji: emoji } = t0;
    const isCompactEndOfPage = appearance === "compact-end-of-page";
    const t1 = !isCompactEndOfPage && $293a049c82938ad0$var$iconBorderStyles;
    let t2;
    if ($[0] !== t1) {
        t2 = [
            t1
        ];
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== emoji || $[3] !== subType || $[4] !== type) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
            type: type,
            emoji: emoji,
            subType: subType
        });
        $[2] = emoji;
        $[3] = subType;
        $[4] = type;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            justifyContent: "center",
            xcss: t2
        }, t3);
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
module.exports["ContentIcon"] = $293a049c82938ad0$export$a1ea799cb5c1b499;

});

parcelRegister("9CEYG", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6F6hl = parcelRequire("6F6hl");


var $jlIaF = parcelRequire("jlIaF");


var $56QzY = parcelRequire("56QzY");


var $dPJCf = parcelRequire("dPJCf");


var $lpPVE = parcelRequire("lpPVE");


var $AXitC = parcelRequire("AXitC");


var $jsaQN = parcelRequire("jsaQN");


var $cxMI6 = parcelRequire("cxMI6");

const $ba0d74007085c540$var$PageLinkComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _154iidpf _1ltvidpf _syaz1j28 _1pbyidpf _rk8tkb7n",
            __cmplp.compact ? "_vn89n7od" : "_vn89bz73",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ba0d74007085c540$export$cf060141faaf6cdf = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { compact: compact, shouldHideFolder: shouldHideFolder, featureAttributionCode: featureAttributionCode } = t0;
    const context = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const { id: id, type: type, status: status, title: t1, links: t2 } = context;
    const { text: text } = t1;
    const { webui: webui } = t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t3;
    if ($[0] !== context || $[1] !== createAnalyticsEvent || $[2] !== id || $[3] !== status || $[4] !== type) {
        t3 = (action, includeNavdex)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: action,
                    actionSubject: (0, $cxMI6.isSpacePageCard)(context) ? "spacePageCard" : "globalPageCard",
                    attributes: {
                        ...includeNavdex && {
                            navdexPointType: (0, $56QzY.START_TOUCH)
                        },
                        contentType: type,
                        contentId: id,
                        contentStatus: status ?? null
                    }
                }
            }).fire();
        };
        $[0] = context;
        $[1] = createAnalyticsEvent;
        $[2] = id;
        $[3] = status;
        $[4] = type;
        $[5] = t3;
    } else t3 = $[5];
    const fireAnalyticsEvent = t3;
    let t4;
    if ($[6] !== featureAttributionCode || $[7] !== fireAnalyticsEvent || $[8] !== push || $[9] !== webui) {
        t4 = (e)=>{
            fireAnalyticsEvent("clicked", true);
            if (featureAttributionCode) {
                e.preventDefault();
                if (e.metaKey || e.ctrlKey) window.open((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(`${(0, $jlIaF.CONTEXT_PATH)}${webui}`, [
                    featureAttributionCode
                ]));
                else push((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(`${(0, $jlIaF.CONTEXT_PATH)}${webui}`, [
                    featureAttributionCode
                ]));
            }
        };
        $[6] = featureAttributionCode;
        $[7] = fireAnalyticsEvent;
        $[8] = push;
        $[9] = webui;
        $[10] = t4;
    } else t4 = $[10];
    const handlePageCardClick = t4;
    let t5;
    if ($[11] !== fireAnalyticsEvent) {
        t5 = (e_0)=>{
            e_0.stopPropagation();
            e_0.preventDefault();
            fireAnalyticsEvent("hovered", false);
        };
        $[11] = fireAnalyticsEvent;
        $[12] = t5;
    } else t5 = $[12];
    const handlePageCardHover = t5;
    const shouldRenderLink = !shouldHideFolder || type !== "folder";
    let t6;
    if ($[13] !== compact || $[14] !== handlePageCardClick || $[15] !== handlePageCardHover || $[16] !== shouldRenderLink || $[17] !== text || $[18] !== webui) {
        t6 = shouldRenderLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba0d74007085c540$var$PageLinkComponent, {
            href: `${(0, $jlIaF.CONTEXT_PATH)}${webui}`,
            onClick: handlePageCardClick,
            onMouseEnter: handlePageCardHover,
            compact: compact
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, text)) : null;
        $[13] = compact;
        $[14] = handlePageCardClick;
        $[15] = handlePageCardHover;
        $[16] = shouldRenderLink;
        $[17] = text;
        $[18] = webui;
        $[19] = t6;
    } else t6 = $[19];
    return t6;
};
module.exports["PageLink"] = $ba0d74007085c540$export$cf060141faaf6cdf;

});

parcelRegister("jsaQN", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $7QM6o = parcelRequire("7QM6o");


var $AXitC = parcelRequire("AXitC");

const $c6d4c54e6938616a$export$3acd67f057972c5d = ()=>{
    const $ = (0, $frIzR.c)(11);
    const { createAnalyticsEvent: akCreateAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { id: id, ranking: ranking, analyticsData: analyticsData, appearance: appearance, type: type } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const spaceId = (0, $7QM6o.useSpaceId)();
    let t0;
    if ($[0] !== akCreateAnalyticsEvent || $[1] !== analyticsData?.attributes || $[2] !== analyticsData?.source || $[3] !== appearance || $[4] !== id || $[5] !== ranking || $[6] !== spaceId || $[7] !== type) {
        t0 = (payload)=>{
            payload.data.objectType = type;
            payload.data.objectId = payload.data.objectId ? payload.data.objectId : id;
            payload.data.containerType = "space";
            payload.data.containerId = spaceId;
            if (appearance === "popup-view") payload.data.actionSubjectId = "pageTree";
            payload.data.source = payload.data.source ? payload.data.source : analyticsData?.source;
            payload.data.attributes = {
                ...payload.data.attributes,
                ...analyticsData?.attributes
            };
            if (typeof ranking === "number") payload.data.attributes.ranking = ranking;
            payload.data.attributes.view = appearance;
            return akCreateAnalyticsEvent(payload);
        };
        $[0] = akCreateAnalyticsEvent;
        $[1] = analyticsData?.attributes;
        $[2] = analyticsData?.source;
        $[3] = appearance;
        $[4] = id;
        $[5] = ranking;
        $[6] = spaceId;
        $[7] = type;
        $[8] = t0;
    } else t0 = $[8];
    const createAnalyticsEvent = t0;
    let t1;
    if ($[9] !== createAnalyticsEvent) {
        t1 = {
            createAnalyticsEvent: createAnalyticsEvent
        };
        $[9] = createAnalyticsEvent;
        $[10] = t1;
    } else t1 = $[10];
    return t1;
};
module.exports["usePageCardAnalyticsEvents"] = $c6d4c54e6938616a$export$3acd67f057972c5d;

});

parcelRegister("63k9q", function(module, exports) {
/* Title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $AXitC = parcelRequire("AXitC");

'use no memo';
const $601474ee7590553b$var$baseStyle = null;
const $601474ee7590553b$var$defaultStyle = null;
const $601474ee7590553b$var$singleLineStyle = null;
const $601474ee7590553b$var$appearanceTitleStyles = {
    grid: "_otyr1b66",
    list: "_11c8fhey _k48pi7a9",
    'compact-list': "",
    'end-of-page': "_11c8i4vh",
    'compact-end-of-page': "_11c8wadc"
};
const $601474ee7590553b$export$f99233281efd08a0 = ({ singleLine: singleLine, ariaLevelOverride: ariaLevelOverride })=>{
    const { id: id, title: { text: text }, appearance: appearance } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: `content-title-${id}`,
        role: "heading",
        "aria-level": ariaLevelOverride ?? 2,
        className: (0, $gMc0m.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _12ji1r31 _1qu2glyw _12y31o36 _syazi7uo _1nrm1r31 _1a3b1r31 _9oik1r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8hi7uo _f8pji7uo _30l3i7uo _1053i7uo",
            "_11c81e3o",
            $601474ee7590553b$var$appearanceTitleStyles[appearance],
            singleLine && "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _1ul9idpf"
        ])
    }, text);
};
module.exports["Title"] = $601474ee7590553b$export$f99233281efd08a0;

});

parcelRegister("kzTi3", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $71GjD = parcelRequire("71GjD");


var $AXitC = parcelRequire("AXitC");


var $dDr80 = parcelRequire("dDr80");

var $aoeyL = parcelRequire("aoeyL");

var $9CEYG = parcelRequire("9CEYG");










var $aXWIB = parcelRequire("aXWIB");


var $bTdbD = parcelRequire("bTdbD");


var $3HOqx = parcelRequire("3HOqx");


var $226KS = parcelRequire("226KS");


var $1bY7o = parcelRequire("1bY7o");





var $c9Olr = parcelRequire("c9Olr");

const $8a88bacc20f8ad66$var$i18n = (0, $aXWIB.defineMessages)({
    BEHAVIORAL: {
        id: "page-card.rec.strategy.behavioral",
        defaultMessage: "Read with this"
    },
    CONTENT_TO_CONTENT: {
        id: "page-card.rec.strategy.content-to-content",
        defaultMessage: "More like this"
    },
    STRUCTURAL: {
        id: "page-card.rec.strategy.structural",
        defaultMessage: "Grouped with this"
    },
    LINKED_CONTENT: {
        id: "page-card.rec.strategy.linked-content",
        defaultMessage: "Linked from this"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8a88bacc20f8ad66$var$StrategyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _1e0c1txw _4cvr1h6o _k48p1wq8 _syazazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $8a88bacc20f8ad66$var$StrategyText = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _18u0u2gc _o5721q9c _1bto1l2s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $8a88bacc20f8ad66$var$Icons = {
    BEHAVIORAL: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bTdbD))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    }),
    CONTENT_TO_CONTENT: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    }),
    STRUCTURAL: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }),
    LINKED_CONTENT: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    })
};
const $8a88bacc20f8ad66$export$96fa1e7da452e6c0 = ()=>{
    const $ = (0, $frIzR.c)(4);
    const { recommendationStrategy: recommendationStrategy } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "STRUCTURAL",
            "BEHAVIORAL",
            "CONTENT_TO_CONTENT",
            "LINKED_CONTENT"
        ];
        $[0] = t0;
    } else t0 = $[0];
    const validRecommendationStrategies = t0;
    const Icon = recommendationStrategy && validRecommendationStrategies.includes(recommendationStrategy) && $8a88bacc20f8ad66$var$Icons[recommendationStrategy];
    let t1;
    if ($[1] !== Icon || $[2] !== recommendationStrategy) {
        t1 = recommendationStrategy && validRecommendationStrategies.includes(recommendationStrategy) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8a88bacc20f8ad66$var$StrategyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, Icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8a88bacc20f8ad66$var$StrategyText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $8a88bacc20f8ad66$var$i18n[recommendationStrategy])))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9Olr.LastAction), null);
        $[1] = Icon;
        $[2] = recommendationStrategy;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};


var $eSkJX = parcelRequire("eSkJX");

var $63k9q = parcelRequire("63k9q");

const $defe7c171d25eb25$var$StyledCard = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $dDr80.Card) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _i0dl1osq _4t3i1osq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $defe7c171d25eb25$var$StyledCardWithHover = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $defe7c171d25eb25$var$StyledCard : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_irr3ufnl",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $defe7c171d25eb25$var$GridCard = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41xcl _1e0c1txw _2lx21bp4 _1bsb1kdh _4t3i1pm2 _c71lgx0z",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $defe7c171d25eb25$var$Header = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 'space.100'
});
const $defe7c171d25eb25$var$HeaderSmallCard = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $defe7c171d25eb25$var$IconContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _19pk1b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $defe7c171d25eb25$var$TitlesContainer = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    overflowWrap: 'break-word',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.050'
});
const $defe7c171d25eb25$var$TitlesContainerSmallCard = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $defe7c171d25eb25$var$TitleContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c8wadc _1e0ccj1k _1yyj11wp _sudp1e54",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $defe7c171d25eb25$var$SubtitleContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _1e0c1txw _1pbyidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $defe7c171d25eb25$var$FooterContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1e0c1txw _4cvresu3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $defe7c171d25eb25$var$FooterBigCard = (0, $ecnYn.xcss)({
    marginTop: 'space.200'
});
const $defe7c171d25eb25$var$Footer = (0, $ecnYn.xcss)({
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $defe7c171d25eb25$export$6a5a043d6c50f30e = (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { showCardsAsListitem: t1 } = t0;
    const showCardsAsListitem = t1 === undefined ? true : t1;
    const { smallCard: smallCard } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const t2 = smallCard ? $defe7c171d25eb25$var$StyledCardWithHover : $defe7c171d25eb25$var$StyledCard;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CEYG.PageLink), {
            featureAttributionCode: (0, $71GjD.FeatureCode).EOP_REC
        });
        $[0] = t3;
    } else t3 = $[0];
    let t4;
    if ($[1] !== smallCard) {
        t4 = [
            $defe7c171d25eb25$var$Header,
            ...smallCard ? [
                $defe7c171d25eb25$var$HeaderSmallCard
            ] : []
        ];
        $[1] = smallCard;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($defe7c171d25eb25$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoeyL.ContentIcon), null));
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== smallCard) {
        t6 = [
            $defe7c171d25eb25$var$TitlesContainer,
            ...smallCard ? [
                $defe7c171d25eb25$var$TitlesContainerSmallCard
            ] : []
        ];
        $[4] = smallCard;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($defe7c171d25eb25$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63k9q.Title), {
            ariaLevelOverride: 3
        }));
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($defe7c171d25eb25$var$SubtitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSkJX.Subtitle), null));
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== t6) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t6
        }, t7, t8);
        $[8] = t6;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== t4 || $[11] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t4
        }, t5, t9);
        $[10] = t4;
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    let t11;
    if ($[13] !== smallCard) {
        t11 = [
            $defe7c171d25eb25$var$Footer,
            ...smallCard ? [] : [
                $defe7c171d25eb25$var$FooterBigCard
            ]
        ];
        $[13] = smallCard;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a88bacc20f8ad66$export$96fa1e7da452e6c0), null);
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t11) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($defe7c171d25eb25$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t11
        }, t12));
        $[16] = t11;
        $[17] = t13;
    } else t13 = $[17];
    let t14;
    if ($[18] !== t10 || $[19] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($defe7c171d25eb25$var$GridCard, {
            "data-testid": "page-card-end-of-page-view"
        }, t10, t13);
        $[18] = t10;
        $[19] = t13;
        $[20] = t14;
    } else t14 = $[20];
    let t15;
    if ($[21] !== showCardsAsListitem || $[22] !== t14 || $[23] !== t2) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dDr80.PageCardContainer), {
            StyledCard: t2,
            isListitem: showCardsAsListitem
        }, t3, t14);
        $[21] = showCardsAsListitem;
        $[22] = t14;
        $[23] = t2;
        $[24] = t15;
    } else t15 = $[24];
    return t15;
};
module.exports["EndOfPageView"] = $defe7c171d25eb25$export$6a5a043d6c50f30e;

});

parcelRegister("c9Olr", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $1YXTQ = parcelRequire("1YXTQ");


var $AXitC = parcelRequire("AXitC");

const $5445257a17f279b7$var$i18n = (0, $aXWIB.defineMessages)({
    edited: {
        id: "page-card.action.you.edited",
        defaultMessage: "You edited {timeAgo}"
    },
    visited: {
        id: "page-card.action.you.visited",
        defaultMessage: "You visited {timeAgo}"
    },
    updated: {
        id: "page-card.action.updated",
        defaultMessage: "Updated {timeAgo}"
    },
    created: {
        id: "page-card.action.created",
        defaultMessage: "Created {timeAgo}"
    },
    createdByYou: {
        id: "page-card.action.created.by.me",
        defaultMessage: "You created {timeAgo}"
    },
    ownedByYou: {
        id: "page-card.action.owned.by.me",
        defaultMessage: "You became owner {timeAgo}"
    },
    liked: {
        id: "page-card.action.liked",
        defaultMessage: "You liked {timeAgo}"
    },
    commented: {
        id: "page-card.action.commented",
        defaultMessage: "You commented {timeAgo}"
    }
});
const $5445257a17f279b7$var$LastActionContainerStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle'
});
const $5445257a17f279b7$var$lastActionTextBaseStyles = null;
const $5445257a17f279b7$var$separatorStyles = (0, $ecnYn.xcss)({
    margin: 'space.050'
});
const $5445257a17f279b7$export$6d375014d3e4edb5 = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { isInlineAction: t1, appearance: appearance } = t0;
    const isInlineAction = t1 === undefined ? false : t1;
    const { lastAction: t2 } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const { action: action, when: when } = t2;
    let t3;
    if ($[0] !== appearance) {
        t3 = appearance === "list" ? {
            justifyContent: "end"
        } : {};
        $[0] = appearance;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== action || $[3] !== isInlineAction || $[4] !== when) {
        t4 = action && when ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, isInlineAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $5445257a17f279b7$var$separatorStyles
        }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _syazuqch"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$5445257a17f279b7$var$i18n[action],
            values: {
                timeAgo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
                    date: when,
                    usePrepositions: true
                })
            }
        }))) : null;
        $[2] = action;
        $[3] = isInlineAction;
        $[4] = when;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            xcss: $5445257a17f279b7$var$LastActionContainerStyles,
            ...t3
        }, t4);
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
};
module.exports["LastAction"] = $5445257a17f279b7$export$6d375014d3e4edb5;

});

parcelRegister("eSkJX", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $1NBp8 = parcelRequire("1NBp8");


var $56QzY = parcelRequire("56QzY");


var $jJK3p = parcelRequire("jJK3p");


var $AXitC = parcelRequire("AXitC");


var $jsaQN = parcelRequire("jsaQN");


var $cxMI6 = parcelRequire("cxMI6");

const $2476ccb0e5f98391$var$i18n = (0, $aXWIB.defineMessages)({
    createdBy: {
        id: "page-card.created.by",
        defaultMessage: "Created by {creator}"
    },
    creatorProfilePictureAlt: {
        id: "page-card.creator.image.label",
        defaultMessage: "Profile picture"
    },
    ownedBy: {
        id: "page-card.owned.by",
        defaultMessage: "Owned by {owner}"
    },
    ownerProfilePictureAlt: {
        id: "page-card.owner.image.label",
        defaultMessage: "Profile picture"
    }
});
const $2476ccb0e5f98391$var$linkStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2476ccb0e5f98391$var$CreatorContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c8wadc _1pbyidpf _o5721q9c _1e0c1txw _4cvr1h6o _syazazsu _kqswh2mm _1ufy15vq _turg15vq _43dsuqch _bpspi7a9 _sjfo1q9c _2cf31l2s _p03cuqch _oavvuqch _oxk4uqch _1cayuqch",
            __cmplp.compact && "_17kn15vq _1hrp15vq _10ca1q9c _x3fa1l2s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2476ccb0e5f98391$var$OwnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c8wadc _1pbyidpf _o5721q9c _1e0c1txw _4cvr1h6o _syazazsu _kqswh2mm _1ufy15vq _turg15vq _43dsuqch _bpspi7a9 _sjfo1q9c _2cf31l2s _p03cuqch _oavvuqch _oxk4uqch _1cayuqch",
            __cmplp.compact && "_17kn15vq _1hrp15vq _10ca1q9c _x3fa1l2s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2476ccb0e5f98391$var$SpaceLink = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c8wadc _1pbykb7n _1bto1l2s _syazazsu _kqswh2mm _1ufy15vq _turg15vq _43dsuqch _bpspi7a9 _sjfo1q9c _2cf31l2s _p03cuqch _oavvuqch _oxk4uqch _1cayuqch",
            __cmplp.compact ? "_dkzun7od" : "_dkzu1y44",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2476ccb0e5f98391$var$Creator = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { displayName: displayName, accountId: accountId } = t0;
    const { appearance: appearance } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const compact = appearance === "compact-list";
    let t1;
    if ($[0] !== accountId || $[1] !== displayName) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$2476ccb0e5f98391$var$i18n.createdBy,
            values: {
                creator: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
                    userId: accountId,
                    fullName: displayName,
                    referralSource: "pageCard"
                })
            }
        });
        $[0] = accountId;
        $[1] = displayName;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== compact || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2476ccb0e5f98391$var$CreatorContainer, {
            compact: compact
        }, t1);
        $[3] = compact;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
const $2476ccb0e5f98391$var$Owner = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { displayName: displayName, accountId: accountId } = t0;
    const { appearance: appearance } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const compact = appearance === "compact-list";
    let t1;
    if ($[0] !== accountId || $[1] !== displayName) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$2476ccb0e5f98391$var$i18n.ownedBy,
            values: {
                owner: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
                    userId: accountId,
                    fullName: displayName,
                    referralSource: "pageCard"
                })
            }
        });
        $[0] = accountId;
        $[1] = displayName;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== compact || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2476ccb0e5f98391$var$OwnerContainer, {
            compact: compact
        }, t1);
        $[3] = compact;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
const $2476ccb0e5f98391$var$Space = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { name: name, spaceKey: spaceKey } = t0;
    const context = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const { appearance: appearance } = context;
    const compact = appearance === "compact-list";
    const endOfPage = appearance === "end-of-page";
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    let t1;
    if ($[0] !== appearance || $[1] !== context || $[2] !== createAnalyticsEvent) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: (0, $cxMI6.isSpacePageCard)(context) ? "spacePageCardSpace" : "globalPageCardSpace",
                    attributes: {
                        navdexPointType: (0, $56QzY.START_TOUCH),
                        appearance: appearance
                    }
                }
            }).fire();
        };
        $[0] = appearance;
        $[1] = context;
        $[2] = createAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] !== spaceKey) {
        t2 = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        });
        $[4] = spaceKey;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== handleClick || $[7] !== name || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: t2,
            onClick: handleClick
        }, name);
        $[6] = handleClick;
        $[7] = name;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== compact || $[11] !== endOfPage || $[12] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2476ccb0e5f98391$var$SpaceLink, {
            compact: compact,
            endOfPage: endOfPage
        }, t3);
        $[10] = compact;
        $[11] = endOfPage;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
};
const $2476ccb0e5f98391$export$cf345ef34cd72655 = ()=>{
    const $ = (0, $frIzR.c)(6);
    const data = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    if ((0, $cxMI6.isSpacePageCard)(data)) {
        let t0;
        if ($[0] !== data.createdBy || $[1] !== data.ownedBy || $[2] !== data.type) {
            t0 = data?.ownedBy && data?.type !== "blogpost" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2476ccb0e5f98391$var$Owner, data.ownedBy) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2476ccb0e5f98391$var$Creator, data.createdBy);
            $[0] = data.createdBy;
            $[1] = data.ownedBy;
            $[2] = data.type;
            $[3] = t0;
        } else t0 = $[3];
        return t0;
    } else {
        let t0;
        if ($[4] !== data.space) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2476ccb0e5f98391$var$Space, data.space);
            $[4] = data.space;
            $[5] = t0;
        } else t0 = $[5];
        return t0;
    }
};
module.exports["Subtitle"] = $2476ccb0e5f98391$export$cf345ef34cd72655;

});

parcelRegister("jb4sa", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $AXitC = parcelRequire("AXitC");


var $7tW57 = parcelRequire("7tW57");

const $18021647e567f5f6$export$6890bd4131e19e85 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { appearance: appearance, data: data, ranking: ranking, analyticsData: analyticsData, children: children, smallCard: smallCard } = t0;
    const [isMenuOpen, setIsMenuOpen] = (0, $42omo.useState)(false);
    const [isViewed, setIsViewed] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            [(0, $7tW57.QuickActionsEnum).ShareButton]: false,
            [(0, $7tW57.QuickActionsEnum).WatchButton]: false
        };
        $[0] = t1;
    } else t1 = $[0];
    const [selectedMenuItems, setSelectedMenuItems] = (0, $42omo.useState)(t1);
    let t2;
    if ($[1] !== analyticsData || $[2] !== appearance || $[3] !== data || $[4] !== isMenuOpen || $[5] !== isViewed || $[6] !== ranking || $[7] !== selectedMenuItems || $[8] !== smallCard) {
        t2 = {
            ...data,
            appearance: appearance,
            setIsMenuOpen: setIsMenuOpen,
            isMenuOpen: isMenuOpen,
            ranking: ranking,
            setSelectedMenuItems: setSelectedMenuItems,
            selectedMenuItems: selectedMenuItems,
            analyticsData: analyticsData,
            isViewed: isViewed,
            setIsViewed: setIsViewed,
            smallCard: smallCard
        };
        $[1] = analyticsData;
        $[2] = appearance;
        $[3] = data;
        $[4] = isMenuOpen;
        $[5] = isViewed;
        $[6] = ranking;
        $[7] = selectedMenuItems;
        $[8] = smallCard;
        $[9] = t2;
    } else t2 = $[9];
    const pageCardContextValue = t2;
    let t3;
    if ($[10] !== children || $[11] !== pageCardContextValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $AXitC.PageCardContext).Provider, {
            value: pageCardContextValue
        }, children);
        $[10] = children;
        $[11] = pageCardContextValue;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
}, (prevProps, nextProps)=>prevProps.appearance === nextProps.appearance && prevProps.data.isStarred === nextProps.data.isStarred);
module.exports["PageCardContextProvider"] = $18021647e567f5f6$export$6890bd4131e19e85;

});

parcelRegister("5BwjK", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $f4Buk = parcelRequire("f4Buk");


var $bQm3c = parcelRequire("bQm3c");


var $AXitC = parcelRequire("AXitC");


var $7aRa9 = parcelRequire("7aRa9");


var $6mKj3 = parcelRequire("6mKj3");

const $38667f05992adc43$var$WrappedButton = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { flags: flags, isEndOfPage: isEndOfPage } = t0;
    const { cloudId: cloudId, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { id: id, type: type, title: title } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    let t1;
    if ($[0] !== cloudId || $[1] !== flags || $[2] !== id || $[3] !== isAIEarlyAccessEnabled || $[4] !== isAdminHubAIEnabled || $[5] !== isEndOfPage || $[6] !== title || $[7] !== type) {
        t1 = isAdminHubAIEnabled && cloudId && type === "page" && (0, $6mKj3.isExperimentEnabled)("confluence_audio_v3") && (!(0, $6mKj3.isExperimentEnabled)("confluence_audio_labs_lozenge") || isAIEarlyAccessEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4Buk.ModifyPlaylistButton), {
            cloudId: cloudId,
            contentId: id,
            contentType: type,
            title: title.text,
            subtle: true,
            flagsOverride: flags,
            actionSource: isEndOfPage ? "endOfPageRecommendations" : "pageTree"
        });
        $[0] = cloudId;
        $[1] = flags;
        $[2] = id;
        $[3] = isAIEarlyAccessEnabled;
        $[4] = isAdminHubAIEnabled;
        $[5] = isEndOfPage;
        $[6] = title;
        $[7] = type;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
};
const $38667f05992adc43$export$dbccb879127f2ec0 = (0, $7aRa9.withFlags)($38667f05992adc43$var$WrappedButton);
module.exports["AudioPlaylistButton"] = $38667f05992adc43$export$dbccb879127f2ec0;

});

parcelRegister("qaY7H", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $tgs13 = parcelRequire("tgs13");


var $jmjWc = parcelRequire("jmjWc");


const $0831fbd07aa65085$export$24022e96df95ff7e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "IH0no",
    name: "LazyAutomationDiscoveryHoverPageTitleMessage",
    loader: async ()=>(await (parcelRequire("aQoBp"))).AutomationDiscoveryHoverPageTitleMessage
});



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $cLo2u = parcelRequire("cLo2u");


var $AXitC = parcelRequire("AXitC");

const $2d4afef340cfe0b2$export$731d798c62feb243 = (lastModifiedDate)=>{
    const getPageUpdatedInSeconds = (lastModifiedRaw)=>{
        const lastModifiedDate = new Date(lastModifiedRaw);
        return (Date.now() - lastModifiedDate.getTime()) / 1000;
    };
    return getPageUpdatedInSeconds(lastModifiedDate) > (0, $tgs13.THREE_HUNDRED_SIXTY_FIVE_DAYS_IN_SECONDS);
};
const $2d4afef340cfe0b2$var$AutomationDiscoveryMessageInner = (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { shouldUseAutomationDiscovery: shouldUseAutomationDiscovery } = t0;
    const { status: status, lastAction: t1, type: type } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const { when: when } = t1;
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    let t2;
    if ($[0] !== shouldUseAutomationDiscovery || $[1] !== status || $[2] !== type || $[3] !== when) {
        t2 = shouldUseAutomationDiscovery && type === "page" && status !== "draft" && $2d4afef340cfe0b2$export$731d798c62feb243(when);
        $[0] = shouldUseAutomationDiscovery;
        $[1] = status;
        $[2] = type;
        $[3] = when;
        $[4] = t2;
    } else t2 = $[4];
    const shouldRender = t2;
    let t3;
    if ($[5] !== shouldRender || $[6] !== spaceKey) {
        t3 = shouldRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0831fbd07aa65085$export$24022e96df95ff7e), {
            spaceKey: spaceKey
        });
        $[5] = shouldRender;
        $[6] = spaceKey;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
};
const $2d4afef340cfe0b2$export$162d8a771575bc85 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
})($2d4afef340cfe0b2$var$AutomationDiscoveryMessageInner);
module.exports["AutomationDiscoveryMessage"] = $2d4afef340cfe0b2$export$162d8a771575bc85;

});

parcelRegister("aQoBp", function(module, exports) {

let $7e51d835c586203c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7e51d835c586203c$var$load("6wr18"),
    $7e51d835c586203c$var$load("45iSI"),
    $7e51d835c586203c$var$load("ffEVr"),
    $7e51d835c586203c$var$load("hhss7"),
    $7e51d835c586203c$var$load("1NKZf")
]).then(()=>parcelRequire('byS2e'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("1R1bQ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9FnLD = parcelRequire("9FnLD");


var $1yB28 = parcelRequire("1yB28");


var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $AXitC = parcelRequire("AXitC");

const $0e708e5e8b7bc139$var$i18n = (0, $aXWIB.defineMessages)({
    likes: {
        id: "page-card.social.likes",
        defaultMessage: "likes"
    },
    comments: {
        id: "page-card.social.comments",
        defaultMessage: "comments"
    }
});
const $0e708e5e8b7bc139$var$socialProofContainerStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest'
});
const $0e708e5e8b7bc139$var$countStyles = (0, $ecnYn.xcss)({
    font: 'font.body.small',
    marginLeft: 'space.025',
    fontWeight: 'font.weight.regular'
});
const $0e708e5e8b7bc139$export$d0fb2e88e6204069 = ()=>{
    const $ = (0, $frIzR.c)(9);
    const { likesCount: likesCount, commentsCount: commentsCount } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const intl = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== intl || $[1] !== likesCount) {
        t0 = likesCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            columnGap: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
            label: intl.formatMessage($0e708e5e8b7bc139$var$i18n.likes)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: $0e708e5e8b7bc139$var$countStyles
        }, likesCount)) : null;
        $[0] = intl;
        $[1] = likesCount;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== commentsCount || $[4] !== intl) {
        t1 = commentsCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            columnGap: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
            label: intl.formatMessage($0e708e5e8b7bc139$var$i18n.comments)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: $0e708e5e8b7bc139$var$countStyles
        }, commentsCount)) : null;
        $[3] = commentsCount;
        $[4] = intl;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== t0 || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            xcss: $0e708e5e8b7bc139$var$socialProofContainerStyles,
            columnGap: "space.150"
        }, t0, t1);
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};
module.exports["SocialProof"] = $0e708e5e8b7bc139$export$d0fb2e88e6204069;

});

parcelRegister("dDu9z", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $inPa6 = parcelRequire("inPa6");


var $71GjD = parcelRequire("71GjD");


var $5BwjK = parcelRequire("5BwjK");

var $qaY7H = parcelRequire("qaY7H");

var $aoeyL = parcelRequire("aoeyL");

var $gETnG = parcelRequire("gETnG");

var $c9Olr = parcelRequire("c9Olr");

var $dDr80 = parcelRequire("dDr80");

var $9CEYG = parcelRequire("9CEYG");

var $1R1bQ = parcelRequire("1R1bQ");

var $fROKr = parcelRequire("fROKr");

var $eSkJX = parcelRequire("eSkJX");

var $63k9q = parcelRequire("63k9q");

const $f2ffb31ca33bfa58$var$styles = {
    container: "_1bsb1kdj",
    header: "_1bsb1osq _1ul9idpf",
    headerIcon: "_1e0c1txw _1bah1yb4 _1o9zidpf",
    titleContainer: "_1ul9idpf _p12f1osq"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2ffb31ca33bfa58$var$FooterContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1e0c1txw _4cvresu3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2ffb31ca33bfa58$var$Footer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1osq _19pkpxbi _1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f2ffb31ca33bfa58$var$CardFooter = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { isEndOfPage: isEndOfPage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9Olr.LastAction), null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1R1bQ.SocialProof), null);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== isEndOfPage) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f2ffb31ca33bfa58$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f2ffb31ca33bfa58$var$Footer, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5BwjK.AudioPlaylistButton), {
            isEndOfPage: isEndOfPage
        }))));
        $[2] = isEndOfPage;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
};
const $f2ffb31ca33bfa58$export$52243c6737c37941 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { shouldUseAutomationDiscovery: shouldUseAutomationDiscovery, isEndOfPage: isEndOfPage } = t0;
    const t1 = isEndOfPage ? (0, $71GjD.FeatureCode).EOP_REC_CARD : (0, $71GjD.FeatureCode).PAGE_TREE_CARD;
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CEYG.PageLink), {
            shouldHideFolder: true,
            featureAttributionCode: t1
        });
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $f2ffb31ca33bfa58$var$styles.headerIcon,
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoeyL.ContentIcon), null));
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            alignBlock: "start",
            alignInline: "start",
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            alignInline: "start",
            shouldWrap: false,
            grow: "fill",
            space: "space.100"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $f2ffb31ca33bfa58$var$styles.header,
            alignBlock: "start",
            alignInline: "start",
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $f2ffb31ca33bfa58$var$styles.titleContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63k9q.Title), {
            singleLine: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSkJX.Subtitle), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fROKr.StatusLozenge), null)));
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gETnG.Excerpt), null);
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    let t6;
    if ($[5] !== isEndOfPage) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            padding: "space.200",
            xcss: $f2ffb31ca33bfa58$var$styles.container,
            testId: "page-card-popup-view"
        }, t4, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f2ffb31ca33bfa58$var$CardFooter, {
            isEndOfPage: isEndOfPage
        }));
        $[5] = isEndOfPage;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== shouldUseAutomationDiscovery) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $qaY7H.AutomationDiscoveryMessage), {
            shouldUseAutomationDiscovery: shouldUseAutomationDiscovery
        });
        $[7] = shouldUseAutomationDiscovery;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== isEndOfPage || $[10] !== t2 || $[11] !== t6 || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f2ffb31ca33bfa58$var$PopupViewBase, {
            isEndOfPage: isEndOfPage
        }, t2, t6, t7);
        $[9] = isEndOfPage;
        $[10] = t2;
        $[11] = t6;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
};
const $f2ffb31ca33bfa58$var$PopupViewBase = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { children: children, isEndOfPage: isEndOfPage } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isEndOfPage) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "confluence",
                    action: "clicked",
                    actionSubject: isEndOfPage ? "relatedContentCard" : "spacePageCard",
                    actionSubjectId: "excerptPopup",
                    attributes: {
                        source: isEndOfPage ? "endOfPageRecommendations" : "pageTree"
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isEndOfPage;
        $[2] = t1;
    } else t1 = $[2];
    const handlePopupClick = t1;
    let t2;
    if ($[3] !== children || $[4] !== handlePopupClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dDr80.PageCardContainer), {
            isHoverPageCard: true,
            onClick: handlePopupClick
        }, children);
        $[3] = children;
        $[4] = handlePopupClick;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
module.exports["PopupView"] = $f2ffb31ca33bfa58$export$52243c6737c37941;

});

parcelRegister("3acIx", function(module, exports) {
/* PageCards.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");


var $4JDbp = parcelRequire("4JDbp");


var $frIzR = parcelRequire("frIzR");














var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $dDr80 = parcelRequire("dDr80");

var $aoeyL = parcelRequire("aoeyL");

var $c9Olr = parcelRequire("c9Olr");

var $9CEYG = parcelRequire("9CEYG");










var $bQm3c = parcelRequire("bQm3c");


var $3dPSK = parcelRequire("3dPSK");


var $2cKGu = parcelRequire("2cKGu");


var $AXitC = parcelRequire("AXitC");








var $aXWIB = parcelRequire("aXWIB");


var $1Zr9M = parcelRequire("1Zr9M");


var $3gadb = parcelRequire("3gadb");


var $de2j9 = parcelRequire("de2j9");


var $sD2Tz = parcelRequire("sD2Tz");


var $jlIaF = parcelRequire("jlIaF");


var $56QzY = parcelRequire("56QzY");


var $39rFu = parcelRequire("39rFu");


var $7NoF3 = parcelRequire("7NoF3");














var $eEA8O = parcelRequire("eEA8O");

const $9435f53888e733e2$export$3c1d9e6f68d6384d = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $eEA8O.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_701wzwfg",
            __cmplp.isSelected ? "_1w901bgf" : "_1w90124n",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});



var $jsaQN = parcelRequire("jsaQN");











// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $146c0ee07cc94a7d$var$HiddenAction = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_v564fxgs _tzy41eg2",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $146c0ee07cc94a7d$var$StaticAction = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1pbykb7n",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $146c0ee07cc94a7d$export$37ab3bdebc286ca = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    const { hidden: hidden } = (0, $42omo.useContext)((0, $7f1b580bd70ac23d$export$e53fea40f770c4e5));
    const Container = hidden ? $146c0ee07cc94a7d$var$HiddenAction : $146c0ee07cc94a7d$var$StaticAction;
    let t1;
    if ($[0] !== Container || $[1] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Container, null, children);
        $[0] = Container;
        $[1] = children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};


const $cea5a5dbb111468f$var$i18n = (0, $aXWIB.defineMessages)({
    edit: {
        id: "page-card.quick-actions.edit.page",
        defaultMessage: "Edit"
    },
    editLabel: {
        id: "page-card.quick-actions.edit.aria-label",
        defaultMessage: "Edit {title}"
    }
});
const $cea5a5dbb111468f$export$a8d3280cb45e38b8 = ()=>{
    const $ = (0, $frIzR.c)(31);
    const { id: id, space: space, type: type, links: t0, appearance: appearance, title: title, editorVersion: editorVersion } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const { editui: editui } = t0;
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const intl = (0, $aXWIB.useIntl)();
    const spaceKey = space?.spaceKey;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const compact = appearance === "compact-list";
    let t1;
    if ($[0] !== editorVersion?.nodes?.[0]?.value) {
        t1 = editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, "");
        $[0] = editorVersion?.nodes?.[0]?.value;
        $[1] = t1;
    } else t1 = $[1];
    const editorVersionValue = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    let t2;
    if ($[2] !== createAnalyticsEvent || $[3] !== isOnEditRoute || $[4] !== type) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "clicked",
                    actionSubject: "editButton",
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        pageType: type,
                        isOnEditRoute: isOnEditRoute
                    }
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = isOnEditRoute;
        $[4] = type;
        $[5] = t2;
    } else t2 = $[5];
    const fireClickAnalytics = t2;
    let t3;
    if ($[6] !== editorVersionValue || $[7] !== editui || $[8] !== fireClickAnalytics || $[9] !== id || $[10] !== loadEditor || $[11] !== spaceKey) {
        t3 = (e)=>{
            fireClickAnalytics();
            e.preventDefault();
            e.stopPropagation();
            loadEditor({
                contentId: id,
                spaceKey: spaceKey,
                redirectUrl: `${(0, $jlIaF.CONTEXT_PATH)}${editui}`,
                isFabricSupported: editorVersionValue === "v2",
                isEmbeddedContent: false
            });
        };
        $[6] = editorVersionValue;
        $[7] = editui;
        $[8] = fireClickAnalytics;
        $[9] = id;
        $[10] = loadEditor;
        $[11] = spaceKey;
        $[12] = t3;
    } else t3 = $[12];
    const handleClick = t3;
    let t4;
    if ($[13] !== intl) {
        t4 = intl.formatMessage($cea5a5dbb111468f$var$i18n.edit);
        $[13] = intl;
        $[14] = t4;
    } else t4 = $[14];
    const t5 = compact ? "compact" : "default";
    const t6 = `${(0, $jlIaF.CONTEXT_PATH)}${editui}`;
    let t7;
    if ($[15] !== intl || $[16] !== title.text) {
        t7 = intl.formatMessage($cea5a5dbb111468f$var$i18n.editLabel, {
            title: title.text
        });
        $[15] = intl;
        $[16] = title.text;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        });
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== handleClick || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9435f53888e733e2$export$3c1d9e6f68d6384d), {
            spacing: t5,
            onClick: handleClick,
            href: t6,
            appearance: "subtle",
            "aria-label": t7,
            iconBefore: t8
        });
        $[19] = handleClick;
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== t4 || $[25] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t4,
            position: "top",
            hideTooltipOnClick: true
        }, t9);
        $[24] = t4;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== id || $[28] !== spaceKey || $[29] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $146c0ee07cc94a7d$export$37ab3bdebc286ca), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $sD2Tz.EditContentButtonPreloader), {
            key: id,
            contentId: id,
            spaceKey: spaceKey,
            isEmbeddedEditor: false,
            editSource: (0, $7NoF3.PAGECARD_EDIT_BUTTON_CLICK)
        }, t10));
        $[27] = id;
        $[28] = spaceKey;
        $[29] = t10;
        $[30] = t11;
    } else t11 = $[30];
    return t11;
};





/**
 * @generated SignedSource<<1f56e92ac23c4ecfd9e167fc9ce9d994>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $60219086504fb31b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StarButtonFolderCardStarFragment",
    "selections": [
        {
            "concreteType": "ConfluenceContentViewerSummary",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceFavoritedSummary",
                    "kind": "LinkedField",
                    "name": "favoritedSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavorite"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ConfluenceFolder"
};
$60219086504fb31b$var$node.hash = "62017b9252e425c5ce11b9dacbcfcca3";
var $60219086504fb31b$export$2e2bcd8739ae039 = $60219086504fb31b$var$node;


/**
 * @generated SignedSource<<40528fac1e436250f19b4a9be91320d0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0d1bb8ea45c63cef$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StarButtonEmbedCardStarFragment",
    "selections": [
        {
            "concreteType": "ConfluenceContentViewerSummary",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceFavoritedSummary",
                    "kind": "LinkedField",
                    "name": "favoritedSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavorite"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ConfluenceEmbed"
};
$0d1bb8ea45c63cef$var$node.hash = "dae3be06d0fda145c168470989cbd584";
var $0d1bb8ea45c63cef$export$2e2bcd8739ae039 = $0d1bb8ea45c63cef$var$node;


/**
 * @generated SignedSource<<21719bfb40423cf6bfda902eed48302b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $51602afe7d2fd9c6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StarButtonDatabaseCardStarFragment",
    "selections": [
        {
            "concreteType": "ConfluenceContentViewerSummary",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceFavoritedSummary",
                    "kind": "LinkedField",
                    "name": "favoritedSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavorite"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ConfluenceDatabase"
};
$51602afe7d2fd9c6$var$node.hash = "a81f85b886dc8719dc1edb9584fcf248";
var $51602afe7d2fd9c6$export$2e2bcd8739ae039 = $51602afe7d2fd9c6$var$node;


/**
 * @generated SignedSource<<7db1bbccd6acc4997ae6299ae11b3718>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dcdb90ac554843b3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StarButtonWhiteboardCardStarFragment",
    "selections": [
        {
            "concreteType": "ConfluenceContentViewerSummary",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceFavoritedSummary",
                    "kind": "LinkedField",
                    "name": "favoritedSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavorite"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ConfluenceWhiteboard"
};
$dcdb90ac554843b3$var$node.hash = "85a390774d106b96e51ecf04f0dab5fb";
var $dcdb90ac554843b3$export$2e2bcd8739ae039 = $dcdb90ac554843b3$var$node;


/**
 * @generated SignedSource<<6e30a1e91fc33e0255091abe6fc193f7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $be47f1068f5cc3f9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StarButtonBlogPostCardStarFragment",
    "selections": [
        {
            "concreteType": "ConfluenceBlogPostViewerSummary",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceFavoritedSummary",
                    "kind": "LinkedField",
                    "name": "favoritedSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavorite"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ConfluenceBlogPost"
};
$be47f1068f5cc3f9$var$node.hash = "2f3c7e7edda1297f958e48ce6c8828a2";
var $be47f1068f5cc3f9$export$2e2bcd8739ae039 = $be47f1068f5cc3f9$var$node;


/**
 * @generated SignedSource<<e9db718671597d314ab47f5e12058f20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5fab506cdf63b5d3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StarButtonPageCardStarFragment",
    "selections": [
        {
            "concreteType": "ConfluencePageViewerSummary",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceFavoritedSummary",
                    "kind": "LinkedField",
                    "name": "favoritedSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavorite"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ConfluencePage"
};
$5fab506cdf63b5d3$var$node.hash = "b8d1619a003756cf35c8239d88418099";
var $5fab506cdf63b5d3$export$2e2bcd8739ae039 = $5fab506cdf63b5d3$var$node;


/**
 * @generated SignedSource<<24612bed63b79a59f49241fe7bfd012c>>
 * @relayHash 865e5f39a31798c3bb25a35cece32ea9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c7cb2b55e80c6bfdd66ab8055ac299fa039a70c5cd23209c338ec4b5427aed5f
const $0ef52d4ce61ef798$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "unfavouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "StarButtonPageCardUnstarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "StarButtonPageCardUnstarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "865e5f39a31798c3bb25a35cece32ea9",
            "id": "c7cb2b55e80c6bfdd66ab8055ac299fa039a70c5cd23209c338ec4b5427aed5f",
            "metadata": {},
            "name": "StarButtonPageCardUnstarMutation",
            "operationKind": "mutation",
            "text": "mutation StarButtonPageCardUnstarMutation($id:ID!){unfavouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite}}}}}}"
        }
    };
}();
$0ef52d4ce61ef798$var$node.hash = "992270a31fd5c901695e35d84cb8d30a";
var $0ef52d4ce61ef798$export$2e2bcd8739ae039 = $0ef52d4ce61ef798$var$node;


/**
 * @generated SignedSource<<3037bc11227f366664838bc9b677ae19>>
 * @relayHash 70c92872d8ccc540bcc28f7f9fc3a1e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4dead3f6527350b99aa2c5192fc9e4c257375934c52323e1c2158604badf0027
const $0e3ed881e0768c90$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "favouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "StarButtonPageCardStarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "StarButtonPageCardStarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "70c92872d8ccc540bcc28f7f9fc3a1e4",
            "id": "4dead3f6527350b99aa2c5192fc9e4c257375934c52323e1c2158604badf0027",
            "metadata": {},
            "name": "StarButtonPageCardStarMutation",
            "operationKind": "mutation",
            "text": "mutation StarButtonPageCardStarMutation($id:ID!){favouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite}}}}}}"
        }
    };
}();
$0e3ed881e0768c90$var$node.hash = "f8033abcb2133c170a7481a2b9cff941";
var $0e3ed881e0768c90$export$2e2bcd8739ae039 = $0e3ed881e0768c90$var$node;









var $kfYj7 = parcelRequire("kfYj7");





var $b3j2Y = parcelRequire("b3j2Y");


var $bvJMy = parcelRequire("bvJMy");


var $gw4Eo = parcelRequire("gw4Eo");





var $ij4CE = parcelRequire("ij4CE");


var $6mKj3 = parcelRequire("6mKj3");















// For forming the typename correctly for content types to enable optimistic updates
const $b6404efbbcc25998$var$capitalizedContentTypes = {
    page: 'Page',
    blogpost: 'BlogPost',
    database: 'Database',
    whiteboard: 'Whiteboard',
    slide: 'Slide',
    embed: 'Embed',
    folder: 'Folder'
};
const $b6404efbbcc25998$export$caa6fc1b5639be76 = (type)=>$b6404efbbcc25998$var$capitalizedContentTypes[type];



var $308Wd = parcelRequire("308Wd");

const $04fcbb12dec9cb03$var$StarButtonPageCardStarMutation = (0, $0e3ed881e0768c90$export$2e2bcd8739ae039);
const $04fcbb12dec9cb03$var$StarButtonPageCardUnstarMutation = (0, $0ef52d4ce61ef798$export$2e2bcd8739ae039);
const $04fcbb12dec9cb03$var$i18n = (0, $aXWIB.defineMessages)({
    star: {
        id: "page-card.star.content.tooltip.label",
        defaultMessage: "Star"
    },
    unstar: {
        id: "page-card.unstar.content.tooltip.label",
        defaultMessage: "Unstar"
    }
});
const $04fcbb12dec9cb03$export$b4b5678234ca6d4d = ()=>{
    const $ = (0, $frIzR.c)(53);
    const { id: id, type: type, isStarred: isStarred, appearance: appearance, analyticsData: analyticsData } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const intl = (0, $aXWIB.useIntl)();
    const compact = appearance === "compact-list";
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            fragmentArtifact: (0, $5fab506cdf63b5d3$export$2e2bcd8739ae039),
            fragmentSpec: (0, $5fab506cdf63b5d3$export$2e2bcd8739ae039)
        };
        $[0] = t0;
    } else t0 = $[0];
    const writePageStarButtonFragment = (0, $ij4CE.useWriteFragmentInterop)({
        ...t0,
        __callerPackage__: "@confluence/page-card"
    });
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            fragmentArtifact: (0, $be47f1068f5cc3f9$export$2e2bcd8739ae039),
            fragmentSpec: (0, $be47f1068f5cc3f9$export$2e2bcd8739ae039)
        };
        $[1] = t1;
    } else t1 = $[1];
    const writeBlogPostStarButtonFragment = (0, $ij4CE.useWriteFragmentInterop)({
        ...t1,
        __callerPackage__: "@confluence/page-card"
    });
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            fragmentArtifact: (0, $dcdb90ac554843b3$export$2e2bcd8739ae039),
            fragmentSpec: (0, $dcdb90ac554843b3$export$2e2bcd8739ae039)
        };
        $[2] = t2;
    } else t2 = $[2];
    const writeWhiteboardStarButtonFragment = (0, $ij4CE.useWriteFragmentInterop)({
        ...t2,
        __callerPackage__: "@confluence/page-card"
    });
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            fragmentArtifact: (0, $51602afe7d2fd9c6$export$2e2bcd8739ae039),
            fragmentSpec: (0, $51602afe7d2fd9c6$export$2e2bcd8739ae039)
        };
        $[3] = t3;
    } else t3 = $[3];
    const writeDatabaseStarButtonFragment = (0, $ij4CE.useWriteFragmentInterop)({
        ...t3,
        __callerPackage__: "@confluence/page-card"
    });
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            fragmentArtifact: (0, $0d1bb8ea45c63cef$export$2e2bcd8739ae039),
            fragmentSpec: (0, $0d1bb8ea45c63cef$export$2e2bcd8739ae039)
        };
        $[4] = t4;
    } else t4 = $[4];
    const writeEmbedStarButtonFragment = (0, $ij4CE.useWriteFragmentInterop)({
        ...t4,
        __callerPackage__: "@confluence/page-card"
    });
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            fragmentArtifact: (0, $60219086504fb31b$export$2e2bcd8739ae039),
            fragmentSpec: (0, $60219086504fb31b$export$2e2bcd8739ae039)
        };
        $[5] = t5;
    } else t5 = $[5];
    const writeFolderStarButtonFragment = (0, $ij4CE.useWriteFragmentInterop)({
        ...t5,
        __callerPackage__: "@confluence/page-card"
    });
    const [star, t6] = (0, $308Wd.useMutationInterop)($04fcbb12dec9cb03$var$StarButtonPageCardStarMutation, {
        __callerPackage__: "@confluence/page-card"
    });
    const { error: starError } = t6;
    const [unstar, t7] = (0, $308Wd.useMutationInterop)($04fcbb12dec9cb03$var$StarButtonPageCardUnstarMutation, {
        __callerPackage__: "@confluence/page-card"
    });
    const { error: unstarError } = t7;
    let t8;
    if ($[6] !== createAnalyticsEvent || $[7] !== type) {
        t8 = (action)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: action,
                    actionSubject: "favouritePage",
                    attributes: {
                        type: type
                    }
                }
            }).fire();
        };
        $[6] = createAnalyticsEvent;
        $[7] = type;
        $[8] = t8;
    } else t8 = $[8];
    const sendAnalyticsEvent = t8;
    let t9;
    if ($[9] !== activationId || $[10] !== cloudId || $[11] !== id || $[12] !== type || $[13] !== writeBlogPostStarButtonFragment || $[14] !== writeDatabaseStarButtonFragment || $[15] !== writeEmbedStarButtonFragment || $[16] !== writeFolderStarButtonFragment || $[17] !== writePageStarButtonFragment || $[18] !== writeWhiteboardStarButtonFragment) {
        t9 = (t10)=>{
            const { newStarredValue: newStarredValue, useAggClient: t11 } = t10;
            const useAggClient = t11 === undefined ? false : t11;
            const capitalizedType = (0, $b6404efbbcc25998$export$caa6fc1b5639be76)(type);
            const dataTypename = `Confluence${capitalizedType}`;
            const starButtonRelayFragments = {
                page: writePageStarButtonFragment,
                blogpost: writeBlogPostStarButtonFragment,
                whiteboard: writeWhiteboardStarButtonFragment,
                slide: writeWhiteboardStarButtonFragment,
                database: writeDatabaseStarButtonFragment,
                embed: writeEmbedStarButtonFragment,
                folder: writeFolderStarButtonFragment
            };
            const writeStarButtonFragment = (type_0)=>starButtonRelayFragments[type_0];
            writeStarButtonFragment(type)({
                fragmentId: `${dataTypename}:${(0, $gw4Eo.getConfluenceContentAri)({
                    siteId: cloudId,
                    resourceType: type,
                    activationId: activationId,
                    resourceId: id
                })}`,
                useAggClient: useAggClient,
                data: {
                    viewer: {
                        favoritedSummary: {
                            isFavorite: newStarredValue,
                            __typename: "ConfluenceFavoritedSummary"
                        },
                        __typename: `Confluence${capitalizedType}ViewerSummary`
                    },
                    __typename: dataTypename
                }
            });
        };
        $[9] = activationId;
        $[10] = cloudId;
        $[11] = id;
        $[12] = type;
        $[13] = writeBlogPostStarButtonFragment;
        $[14] = writeDatabaseStarButtonFragment;
        $[15] = writeEmbedStarButtonFragment;
        $[16] = writeFolderStarButtonFragment;
        $[17] = writePageStarButtonFragment;
        $[18] = writeWhiteboardStarButtonFragment;
        $[19] = t9;
    } else t9 = $[19];
    const modifyStarCache = t9;
    const shouldUseAGGActivityV3 = $04fcbb12dec9cb03$var$_temp;
    let t10;
    if ($[20] !== analyticsData?.source || $[21] !== id || $[22] !== modifyStarCache || $[23] !== sendAnalyticsEvent || $[24] !== star) {
        t10 = (e)=>{
            e.stopPropagation();
            star({
                variables: {
                    id: id
                },
                optimisticResponse: {
                    favouritePage: {
                        __typename: "FavouritePagePayload",
                        content: {
                            __typename: "Content",
                            id: id,
                            metadata: {
                                __typename: "ContentMetadata",
                                currentuser: {
                                    __typename: "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    favourited: {
                                        __typename: "FavouritedSummary",
                                        isFavourite: true
                                    }
                                }
                            }
                        }
                    }
                }
            });
            sendAnalyticsEvent("created");
            if (analyticsData?.source === "recentScreen") modifyStarCache({
                newStarredValue: true,
                useAggClient: shouldUseAGGActivityV3()
            });
            else modifyStarCache({
                newStarredValue: true,
                useAggClient: true
            });
        };
        $[20] = analyticsData?.source;
        $[21] = id;
        $[22] = modifyStarCache;
        $[23] = sendAnalyticsEvent;
        $[24] = star;
        $[25] = t10;
    } else t10 = $[25];
    analyticsData?.source;
    const onStarClick = t10;
    let t11;
    if ($[26] !== analyticsData?.source || $[27] !== id || $[28] !== modifyStarCache || $[29] !== sendAnalyticsEvent || $[30] !== unstar) {
        t11 = (e_0)=>{
            e_0.stopPropagation();
            unstar({
                variables: {
                    id: id
                },
                optimisticResponse: {
                    unfavouritePage: {
                        __typename: "FavouritePagePayload",
                        content: {
                            __typename: "Content",
                            id: id,
                            metadata: {
                                __typename: "ContentMetadata",
                                currentuser: {
                                    __typename: "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    favourited: null
                                }
                            }
                        }
                    }
                }
            });
            sendAnalyticsEvent("deleted");
            if (analyticsData?.source === "recentScreen") modifyStarCache({
                newStarredValue: false,
                useAggClient: shouldUseAGGActivityV3()
            });
            else modifyStarCache({
                newStarredValue: false,
                useAggClient: true
            });
        };
        $[26] = analyticsData?.source;
        $[27] = id;
        $[28] = modifyStarCache;
        $[29] = sendAnalyticsEvent;
        $[30] = unstar;
        $[31] = t11;
    } else t11 = $[31];
    analyticsData?.source;
    const onUnstarClick = t11;
    let t12;
    if ($[32] !== intl || $[33] !== isStarred) {
        t12 = isStarred ? intl.formatMessage($04fcbb12dec9cb03$var$i18n.unstar) : intl.formatMessage($04fcbb12dec9cb03$var$i18n.star);
        $[32] = intl;
        $[33] = isStarred;
        $[34] = t12;
    } else t12 = $[34];
    const tooltipLabel = t12;
    let t13;
    if ($[35] !== starError) {
        t13 = starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: starError
        });
        $[35] = starError;
        $[36] = t13;
    } else t13 = $[36];
    let t14;
    if ($[37] !== unstarError) {
        t14 = unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: unstarError
        });
        $[37] = unstarError;
        $[38] = t14;
    } else t14 = $[38];
    let t15;
    if ($[39] !== compact || $[40] !== id || $[41] !== intl || $[42] !== isStarred || $[43] !== onStarClick || $[44] !== onUnstarClick) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9435f53888e733e2$export$3c1d9e6f68d6384d), {
            id: `star-button-${id}`,
            spacing: compact ? "compact" : "default",
            appearance: "subtle",
            onClick: onUnstarClick,
            "aria-label": intl.formatMessage($04fcbb12dec9cb03$var$i18n.star),
            "aria-pressed": isStarred,
            "aria-labelledby": `star-button-${id} content-title-${id}`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bvJMy.StarSelectedIcon), {
                label: ""
            }),
            testId: "page-unstar-button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $146c0ee07cc94a7d$export$37ab3bdebc286ca), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9435f53888e733e2$export$3c1d9e6f68d6384d), {
            id: `star-button-${id}`,
            spacing: compact ? "compact" : "default",
            appearance: "subtle",
            onClick: onStarClick,
            "aria-label": intl.formatMessage($04fcbb12dec9cb03$var$i18n.star),
            "aria-pressed": isStarred,
            "aria-labelledby": `star-button-${id} content-title-${id}`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
                label: ""
            }),
            testId: "page-star-button"
        })));
        $[39] = compact;
        $[40] = id;
        $[41] = intl;
        $[42] = isStarred;
        $[43] = onStarClick;
        $[44] = onUnstarClick;
        $[45] = t15;
    } else t15 = $[45];
    let t16;
    if ($[46] !== t15 || $[47] !== tooltipLabel) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipLabel,
            position: "top",
            hideTooltipOnClick: true
        }, t15);
        $[46] = t15;
        $[47] = tooltipLabel;
        $[48] = t16;
    } else t16 = $[48];
    let t17;
    if ($[49] !== t13 || $[50] !== t14 || $[51] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t13, t14, t16);
        $[49] = t13;
        $[50] = t14;
        $[51] = t16;
        $[52] = t17;
    } else t17 = $[52];
    return t17;
};
function $04fcbb12dec9cb03$var$_temp() {
    if ((0, $6mKj3.expValEquals)("cc_migrate_activity_v3_recents_queries_to_agg", "isEnabled", true)) return true;
    const isDefaultDomain = window.location.hostname.endsWith(".atlassian.net") || window.location.hostname.endsWith(".jira-dev.com");
    return !isDefaultDomain;
}












var $8cjip = parcelRequire("8cjip");


var $fCjCI = parcelRequire("fCjCI");





var $4c4ke = parcelRequire("4c4ke");


var $5EoFB = parcelRequire("5EoFB");


var $bl4QJ = parcelRequire("bl4QJ");












var $7tW57 = parcelRequire("7tW57");

const $ac97a98bde54329f$export$8091e3849c182a6 = (menuItem, isSelected)=>{
    const { setIsMenuOpen: setIsMenuOpen, setSelectedMenuItems: setSelectedMenuItems, selectedMenuItems: selectedMenuItems } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    (0, $42omo.useEffect)(()=>{
        setSelectedMenuItems({
            ...selectedMenuItems,
            [menuItem]: isSelected
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSelected
    ]);
    (0, $42omo.useEffect)(()=>{
        if (selectedMenuItems[(0, $7tW57.QuickActionsEnum).WatchButton] || selectedMenuItems[(0, $7tW57.QuickActionsEnum).ShareButton]) setIsMenuOpen(true);
        else setIsMenuOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedMenuItems
    ]);
};








const $c75091fbd7089ca4$var$i18n = (0, $aXWIB.defineMessages)({
    watch: {
        id: "page-card.quick-actions.watch.page",
        defaultMessage: "Watch"
    },
    unwatch: {
        id: "page-card.quick-actions.unwatch.page",
        defaultMessage: "Unwatch"
    },
    watchLabel: {
        id: "page-card.quick-actions.watch.aria-label",
        defaultMessage: "Watch {title}"
    },
    unwatchLabel: {
        id: "page-card.quick-actions.unwatch.aria-label",
        defaultMessage: "Unwatch {title}"
    }
});
const $c75091fbd7089ca4$export$41b9225b77f84823 = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { isWatching: isWatching, isSelected: isSelected, triggerProps: triggerProps, onClick: onClick, onMouseOver: onMouseOver } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    (0, $ac97a98bde54329f$export$8091e3849c182a6)((0, $7tW57.QuickActionsEnum).WatchButton, isSelected);
    const { type: type, appearance: appearance, title: title } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const intl = (0, $aXWIB.useIntl)();
    const compact = appearance === "compact-list";
    let t1;
    if ($[0] !== intl || $[1] !== isWatching || $[2] !== title.text) {
        t1 = isWatching ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($fCjCI))),
            intl.formatMessage($c75091fbd7089ca4$var$i18n.unwatch),
            intl.formatMessage($c75091fbd7089ca4$var$i18n.unwatchLabel, {
                title: title.text
            })
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($8cjip))),
            intl.formatMessage($c75091fbd7089ca4$var$i18n.watch),
            intl.formatMessage($c75091fbd7089ca4$var$i18n.watchLabel, {
                title: title.text
            })
        ];
        $[0] = intl;
        $[1] = isWatching;
        $[2] = title.text;
        $[3] = t1;
    } else t1 = $[3];
    const [Icon, label, ariaLabel] = t1;
    let t2;
    if ($[4] !== createAnalyticsEvent || $[5] !== onClick || $[6] !== type) {
        t2 = ()=>{
            onClick();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "content-watch-button",
                    attributes: {
                        contentType: type
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = onClick;
        $[6] = type;
        $[7] = t2;
    } else t2 = $[7];
    const handleWatchClick = t2;
    const t3 = compact ? "compact" : "default";
    let t4;
    if ($[8] !== Icon) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: ""
        });
        $[8] = Icon;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== triggerProps) {
        t5 = triggerProps || {};
        $[10] = triggerProps;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== ariaLabel || $[13] !== handleWatchClick || $[14] !== isSelected || $[15] !== onMouseOver || $[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9435f53888e733e2$export$3c1d9e6f68d6384d), {
            spacing: t3,
            appearance: "subtle",
            onClick: handleWatchClick,
            onMouseOver: onMouseOver,
            isSelected: isSelected,
            "aria-label": ariaLabel,
            iconBefore: t4,
            ...t5
        }));
        $[12] = ariaLabel;
        $[13] = handleWatchClick;
        $[14] = isSelected;
        $[15] = onMouseOver;
        $[16] = t3;
        $[17] = t4;
        $[18] = t5;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== label || $[21] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: label,
            position: "top",
            hideTooltipOnClick: true
        }, t6);
        $[20] = label;
        $[21] = t6;
        $[22] = t7;
    } else t7 = $[22];
    return t7;
};
const $c75091fbd7089ca4$export$e149a93a7ac7f896 = ()=>{
    const $ = (0, $frIzR.c)(4);
    const { id: id, appearance: appearance, isViewed: isViewed } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const compact = appearance === "compact-list";
    let t0;
    if ($[0] !== compact || $[1] !== id || $[2] !== isViewed) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $146c0ee07cc94a7d$export$37ab3bdebc286ca), null, isViewed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4c4ke.WatchDialog), {
            contentId: id,
            defaultTab: (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE,
            customTrigger: $c75091fbd7089ca4$export$41b9225b77f84823,
            useShortcut: false,
            compact: compact
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bl4QJ.WatchButtonPlaceholder), {
            compact: compact
        }));
        $[0] = compact;
        $[1] = id;
        $[2] = isViewed;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};









var $hkzol = parcelRequire("hkzol");





const $6e589e112b83e5ab$export$534d10f1c5b9c7b3 = (_)=>{
    const $ = (0, $frIzR.c)(5);
    const { id: contentId, type: contentType, space: space, analyticsData: analyticsData } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const t0 = space?.spaceKey ?? "";
    const t1 = analyticsData?.source ?? "";
    let t2;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== t0 || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $146c0ee07cc94a7d$export$37ab3bdebc286ca), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hkzol.CopyLinkButton), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: t0,
            source: t1,
            buttonAppearance: "subtle",
            tooltipPosition: "top"
        }));
        $[0] = contentId;
        $[1] = contentType;
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};


const $7f1b580bd70ac23d$export$e53fea40f770c4e5 = /*#__PURE__*/ (0, $42omo.createContext)({
    hidden: true
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7f1b580bd70ac23d$var$QuickActionsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1e0c1txw _4cvr1h6o",
            __cmplp.compact ? "_1bahesu3" : "_1bahn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $7f1b580bd70ac23d$var$QuickActionsListItem = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "li" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $7f1b580bd70ac23d$var$PlaceholderAction = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "li" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsbzwfg _19pkidpf",
            __cmplp.compact ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $7f1b580bd70ac23d$var$defaultActions = [
    'edit',
    'copy',
    'watch',
    'star'
];
const $7f1b580bd70ac23d$var$useEnabledActions = ()=>{
    const $ = (0, $frIzR.c)(21);
    const isStarringEnabledForDatabases = (0, $2cKGu.useIsStarringEnabled)("database");
    const isWatchingWhiteboardsEnabled = (0, $3dPSK.useIsWatchDialogEnabled)("whiteboard");
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { status: status, type: type, subType: subType } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    if (!isLicensed || status === "draft") {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = [];
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "copy",
            "star"
        ];
        $[1] = t0;
    } else t0 = $[1];
    const contentActions = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "watch"
        ];
        $[2] = t1;
    } else t1 = $[2];
    const watchAction = t1;
    let t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        const livePageActions = $7f1b580bd70ac23d$var$defaultActions.filter($7f1b580bd70ac23d$var$_temp);
        t2 = {
            none: $7f1b580bd70ac23d$var$defaultActions,
            live: livePageActions
        };
        t3 = {
            none: $7f1b580bd70ac23d$var$defaultActions
        };
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    let t4;
    if ($[5] !== isWatchingWhiteboardsEnabled) {
        t4 = {
            none: [
                ...contentActions,
                ...isWatchingWhiteboardsEnabled ? watchAction : []
            ]
        };
        $[5] = isWatchingWhiteboardsEnabled;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isWatchingWhiteboardsEnabled) {
        t5 = {
            none: [
                ...contentActions,
                ...isWatchingWhiteboardsEnabled ? watchAction : []
            ]
        };
        $[7] = isWatchingWhiteboardsEnabled;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== isStarringEnabledForDatabases) {
        t6 = {
            none: isStarringEnabledForDatabases ? contentActions : []
        };
        $[9] = isStarringEnabledForDatabases;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            none: contentActions
        };
        t8 = {
            none: contentActions
        };
        $[11] = t7;
        $[12] = t8;
    } else {
        t7 = $[11];
        t8 = $[12];
    }
    let t9;
    if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
        t9 = {
            page: t2,
            blogpost: t3,
            whiteboard: t4,
            slide: t5,
            database: t6,
            embed: t7,
            folder: t8
        };
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = t9;
    } else t9 = $[16];
    const typeActionMap = t9;
    let t10;
    if ($[17] !== subType || $[18] !== type || $[19] !== typeActionMap) {
        t10 = typeActionMap[type]?.[subType ?? "none"] || [];
        $[17] = subType;
        $[18] = type;
        $[19] = typeActionMap;
        $[20] = t10;
    } else t10 = $[20];
    return t10;
};
const $7f1b580bd70ac23d$export$626874e33f1a0310 = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { actions: t1, hidden: hidden, compact: compact } = t0;
    const actions = t1 === undefined ? $7f1b580bd70ac23d$var$defaultActions : t1;
    const enabledActions = $7f1b580bd70ac23d$var$useEnabledActions();
    const numberOfPlaceholders = $7f1b580bd70ac23d$var$defaultActions.length - enabledActions.length;
    const t2 = Boolean(hidden);
    let t3;
    if ($[0] !== t2) {
        t3 = {
            hidden: t2
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const quickActionsContextValue = t3;
    let t4;
    if ($[2] !== compact || $[3] !== numberOfPlaceholders) {
        let t5;
        if ($[5] !== compact) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7f1b580bd70ac23d$var$PlaceholderAction, {
                compact: compact
            });
            $[5] = compact;
            $[6] = t5;
        } else t5 = $[6];
        t4 = Array(numberOfPlaceholders).fill(t5);
        $[2] = compact;
        $[3] = numberOfPlaceholders;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[7] !== actions || $[8] !== enabledActions) {
        let t6;
        if ($[10] !== enabledActions) {
            t6 = (action)=>{
                let actionButton;
                bb8: switch(enabledActions.includes(action) ? action : null){
                    case "edit":
                        actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cea5a5dbb111468f$export$a8d3280cb45e38b8), {
                            key: action
                        });
                        break bb8;
                    case "copy":
                        actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e589e112b83e5ab$export$534d10f1c5b9c7b3), {
                            key: action
                        });
                        break bb8;
                    case "watch":
                        actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c75091fbd7089ca4$export$e149a93a7ac7f896), {
                            key: action
                        });
                        break bb8;
                    case "star":
                        actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04fcbb12dec9cb03$export$b4b5678234ca6d4d), {
                            key: action
                        });
                        break bb8;
                    default:
                        actionButton = null;
                }
                return actionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7f1b580bd70ac23d$var$QuickActionsListItem, {
                    key: action
                }, actionButton) : null;
            };
            $[10] = enabledActions;
            $[11] = t6;
        } else t6 = $[11];
        t5 = actions.map(t6);
        $[7] = actions;
        $[8] = enabledActions;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[12] !== compact || $[13] !== t4 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7f1b580bd70ac23d$var$QuickActionsContainer, {
            compact: compact
        }, t4, t5);
        $[12] = compact;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== quickActionsContextValue || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7f1b580bd70ac23d$export$e53fea40f770c4e5.Provider, {
            value: quickActionsContextValue
        }, t6);
        $[16] = quickActionsContextValue;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
};
function $7f1b580bd70ac23d$var$_temp(item) {
    return item !== "edit";
}


var $fROKr = parcelRequire("fROKr");

var $eSkJX = parcelRequire("eSkJX");

var $63k9q = parcelRequire("63k9q");


var $4xawV = parcelRequire("4xawV");

const $838b83bb70ba05a9$var$listCardStyle = null;
const $838b83bb70ba05a9$var$gridTemplateColumnsMap = {
    FULL: '32px minmax(300px, 2fr) 1fr 1fr 128px',
    NO_LAST_ACTION: '32px minmax(300px, 2fr) 1fr 0fr 128px',
    NO_SUBTITLE: '32px minmax(300px, 2fr) 0fr 0fr 128px'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$StyledCard = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $dDr80.Card) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19itia51 _2rkoidpf _n7zlglyw _16qsglyw _1dbzglyw _irr3ysee _1vjwazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$TitleContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$ContentIconContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2hwxpxbi _4t3i7vkz _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$RoundedCornerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_x5031mok _1snx1mok",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$TitleText = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2hwxu2gc _o5721q9c _1bto1l2s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $838b83bb70ba05a9$var$statusContainerStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$SubtitleContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2hwxu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $838b83bb70ba05a9$var$LastActionContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2hwxu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $838b83bb70ba05a9$export$f9e5c039a4efefae = ()=>{
    const $ = (0, $frIzR.c)(12);
    const { width: width } = (0, $42omo.useContext)((0, $4xawV.PageCardsContext));
    let breakPoint = "FULL";
    if (width < 700) breakPoint = "NO_SUBTITLE";
    else if (width < 900) breakPoint = "NO_LAST_ACTION";
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CEYG.PageLink), {
            compact: true
        });
        $[0] = t0;
    } else t0 = $[0];
    const t1 = $838b83bb70ba05a9$var$gridTemplateColumnsMap[breakPoint];
    let t2;
    if ($[1] !== t1) {
        t2 = {
            gridTemplateColumns: t1
        };
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $gMc0m.default)([
            "_1yt41pyq _1ul9idpf _1e0c11p5 _4cvr1h6o"
        ]);
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($838b83bb70ba05a9$var$ContentIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoeyL.ContentIcon), null));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($838b83bb70ba05a9$var$TitleText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63k9q.Title), {
            singleLine: true
        }));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($838b83bb70ba05a9$var$TitleContainer, null, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $838b83bb70ba05a9$var$statusContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fROKr.StatusLozenge), null)));
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($838b83bb70ba05a9$var$SubtitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSkJX.Subtitle), null));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    let t9;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($838b83bb70ba05a9$var$LastActionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9Olr.LastAction), null));
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f1b580bd70ac23d$export$626874e33f1a0310), {
            hidden: true,
            compact: true
        });
        $[8] = t8;
        $[9] = t9;
    } else {
        t8 = $[8];
        t9 = $[9];
    }
    let t10;
    if ($[10] !== t2) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($838b83bb70ba05a9$var$RoundedCornerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dDr80.PageCardContainer), {
            StyledCard: $838b83bb70ba05a9$var$StyledCard,
            isListitem: true
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: t2,
            "data-testid": "page-card-compact-list-view",
            className: t3
        }, t4, t6, t7, t8, t9)));
        $[10] = t2;
        $[11] = t10;
    } else t10 = $[11];
    return t10;
};


var $kzTi3 = parcelRequire("kzTi3");










var $1s5hv = parcelRequire("1s5hv");




var $gETnG = parcelRequire("gETnG");







var $1R1bQ = parcelRequire("1R1bQ");







// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87f8c933d272d979$var$GridCard = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41xcl _1e0c1txw _2lx21bp4 _4t3i1pm2 _1bsb1kdh _c71lgx0z",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87f8c933d272d979$var$TitleContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s81f27 _11c81af2 _1reo15vq _18m915vq _1bto1l2s _1i4q1hna _1e0ccj1k _1yyjcs5v _sudp1e54",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87f8c933d272d979$var$FooterContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1e0c1txw _4cvresu3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87f8c933d272d979$var$Footer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1osq _19pkpxbi _1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $87f8c933d272d979$export$5a87d90ca5d04034 = ()=>{
    const $ = (0, $frIzR.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CEYG.PageLink), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            justifyContent: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoeyL.ContentIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f1b580bd70ac23d$export$626874e33f1a0310), {
            hidden: true
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87f8c933d272d979$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63k9q.Title), null));
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSkJX.Subtitle), null);
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fROKr.StatusLozenge), {
            isInColumn: true
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gETnG.Excerpt), null);
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else {
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dDr80.PageCardContainer), {
            isListitem: true
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87f8c933d272d979$var$GridCard, {
            "data-testid": "page-card-grid-view"
        }, t1, t2, t3, t4, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87f8c933d272d979$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87f8c933d272d979$var$Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9Olr.LastAction), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1R1bQ.SocialProof), null)))));
        $[6] = t6;
    } else t6 = $[6];
    return t6;
};

/* ListView.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















'use no memo';
const $089b4dc59c13daf7$var$listCardStyles = null;
const $089b4dc59c13daf7$var$titleContainerStyles = null;
const $089b4dc59c13daf7$var$contentIconStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $089b4dc59c13daf7$var$MainContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlgrho _1wpz1y6m _1ul91mjv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $089b4dc59c13daf7$var$TitleText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2hwxu2gc _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $089b4dc59c13daf7$var$lastActionContainerStyles = null;
const $089b4dc59c13daf7$export$84d0dd190d551cd1 = ()=>{
    // ⚠️ WARNING: Do you need to add conditional logic? Please refer to README#Views ⚠️
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dDr80.PageCardContainer), {
        isListitem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CEYG.PageLink), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "page-card-list-view",
        className: (0, $gMc0m.default)([
            "_1yt41pyq _1ul9idpf _1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_18s8plhh _1wpz1y6m"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoeyL.ContentIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($089b4dc59c13daf7$var$MainContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($089b4dc59c13daf7$var$TitleText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63k9q.Title), {
        singleLine: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fROKr.StatusLozenge), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSkJX.Subtitle), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f1b580bd70ac23d$export$626874e33f1a0310), {
        hidden: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlidpf _1o9zkb7n _i0dl1wdt _1ul953f4 _y3gnusic"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9Olr.LastAction), {
        appearance: "list"
    }))));
};


var $dDu9z = parcelRequire("dDu9z");


var $jb4sa = parcelRequire("jb4sa");

const $53e35d7d38738d3f$var$getViewComponent = (appearance)=>{
    switch(appearance){
        case 'grid':
            return 0, $87f8c933d272d979$export$5a87d90ca5d04034;
        case 'list':
            return 0, $089b4dc59c13daf7$export$84d0dd190d551cd1;
        case 'compact-list':
            return 0, $838b83bb70ba05a9$export$f9e5c039a4efefae;
        case 'popup-view':
            return 0, $dDu9z.PopupView;
        case 'end-of-page':
            return 0, $kzTi3.EndOfPageView;
        case 'compact-end-of-page':
            return 0, $kzTi3.EndOfPageView;
    }
};
const $53e35d7d38738d3f$export$832e93955c36efe9 = (wrapperProps)=>{
    const $ = (0, $frIzR.c)(7);
    let t0;
    if ($[0] !== wrapperProps.appearance) {
        t0 = $53e35d7d38738d3f$var$getViewComponent(wrapperProps.appearance);
        $[0] = wrapperProps.appearance;
        $[1] = t0;
    } else t0 = $[1];
    const View = t0;
    let t1;
    if ($[2] !== View) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(View, null);
        $[2] = View;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t1 || $[5] !== wrapperProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jb4sa.PageCardContextProvider), wrapperProps, t1);
        $[4] = t1;
        $[5] = wrapperProps;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};





'use no memo';
const $18632bf01698551b$var$pageCardConainerStyles = {
    grid: "_zulppxbi _1e0c11p5 _1ul9aq3k _p12f1bp9 _yv0e93b1",
    list: "_1e0c1txw _2lx21bp4 _1ul91ogm _1g96idpf _1fuqglyw _17wxglyw _1nb4ysee _1c2cazsu _1s5uglyw _10ss1mok _yt3j1mok _p39gidpf _w5qfidpf _yeslia51 _b4owidpf _dcakidpf _1bbc1mok _1wzb1mok",
    'compact-list': ""
};
const $18632bf01698551b$export$a92f8045b239279b = ({ appearance: appearance, nodes: nodes, analyticsData: analyticsData })=>{
    const [width, setWidth] = (0, $42omo.useState)(0);
    const onResize = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(setWidth, 200, {
        leading: false
    });
    const pageCardsContextValue = (0, $42omo.useMemo)(()=>({
            width: width
        }), [
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4xawV.PageCardsContext).Provider, {
        value: pageCardsContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "list",
        className: (0, $gMc0m.default)([
            $18632bf01698551b$var$pageCardConainerStyles[appearance]
        ])
    }, nodes.map((node, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $53e35d7d38738d3f$export$832e93955c36efe9), {
            appearance: appearance,
            data: node,
            key: node.key || node.id,
            ranking: i,
            analyticsData: analyticsData
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4JDbp.default), {
        setWidth: onResize,
        offscreen: true
    })));
};
module.exports["PageCards"] = $18632bf01698551b$export$a92f8045b239279b;

});

parcelRegister("lBLrW", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");





var $3u0dr = parcelRequire("3u0dr");








var $aaEXZ = parcelRequire("aaEXZ");

const $fb6e993b302714b6$export$e6090e20fb1e56e9 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(4);
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || "";
    let t0;
    if ($[0] !== label || $[1] !== primaryColor || $[2] !== props.testId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aaEXZ))), {
            label: label,
            color: primaryColor,
            spacing: "spacious",
            testId: props.testId
        });
        $[0] = label;
        $[1] = primaryColor;
        $[2] = props.testId;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aaEXZ))), {
        label: label,
        color: primaryColor,
        spacing: "spacious",
        testId: props.testId
    });
};


const $892d154fe52aa703$export$f0f500e4832f7ca4 = ({ label: label, primaryColor: primaryColor, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb6e993b302714b6$export$e6090e20fb1e56e9), {
        label: label,
        testId: testId,
        primaryColor: primaryColor
    });
};














var $dk0le = parcelRequire("dk0le");

const $0471bf2ec075209c$export$3570ac4c3e881cb1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(4);
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || "";
    let t0;
    if ($[0] !== label || $[1] !== primaryColor || $[2] !== props.testId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dk0le))), {
            color: primaryColor,
            spacing: "spacious",
            label: label,
            testId: props.testId
        });
        $[0] = label;
        $[1] = primaryColor;
        $[2] = props.testId;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dk0le))), {
        color: primaryColor,
        spacing: "spacious",
        label: label,
        testId: props.testId
    });
};


const $f1bed3656a6df92d$export$fa17e9a974485717 = ({ label: label, primaryColor: primaryColor, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0471bf2ec075209c$export$3570ac4c3e881cb1), {
        label: label,
        testId: testId,
        primaryColor: primaryColor
    });
};














var $ai9UQ = parcelRequire("ai9UQ");

const $0bd5fe9912278910$export$4c9b65bdcf92ad22 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(4);
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || "";
    let t0;
    if ($[0] !== label || $[1] !== primaryColor || $[2] !== props.testId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ai9UQ))), {
            label: label,
            color: primaryColor,
            spacing: "spacious",
            testId: props.testId
        });
        $[0] = label;
        $[1] = primaryColor;
        $[2] = props.testId;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ai9UQ))), {
        label: label,
        color: primaryColor,
        spacing: "spacious",
        testId: props.testId
    });
};


const $781dc60d1c0744fb$export$230671d7ba50d3c8 = ({ label: label, primaryColor: primaryColor, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0bd5fe9912278910$export$4c9b65bdcf92ad22), {
        label: label,
        testId: testId,
        primaryColor: primaryColor
    });
};


/* PageCardAppearanceOption.tsx generated by @compiled/babel-plugin v0.36.1 */ 





'use no memo';
const $83cf45b7dcdaab8f$var$inputStyle = null;
const $83cf45b7dcdaab8f$var$baseLabelStyle = null;
const $83cf45b7dcdaab8f$var$hoverAndFocusStyle = null;
const $83cf45b7dcdaab8f$var$selectedHoverAndFocusStyles = null;
const $83cf45b7dcdaab8f$var$disabledStyle = null;
const $83cf45b7dcdaab8f$export$38dfdd608e2cb4f4 = ({ isChecked: isChecked, onClick: onClick, ToggleIcon: ToggleIcon, disabled: disabled = false, label: label })=>{
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    const toggleFocus = (0, $42omo.useCallback)(()=>{
        setIsFocused(!isFocused);
    }, [
        isFocused
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("label", {
        className: (0, $gMc0m.default)([
            "_2rko12b0 _ae4v1h6o _1bah1h6o _1e0c1txw _80omtlke _4cvr1h6o",
            disabled && "_80om13gf",
            isChecked && !disabled ? "_1e387g83 _19h6fajl _7glxidpf _irr3ysee" : "_irr3ysee"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "radio",
        name: "project-type-selection",
        checked: isChecked,
        onClick: onClick,
        onFocus: toggleFocus,
        onBlur: toggleFocus,
        "aria-checked": isChecked,
        "aria-label": label,
        disabled: disabled,
        className: (0, $gMc0m.default)([
            "_kqswstnw _tzy4idpf _lcxvglyw _4t3i1ejb _1bsb1ejb"
        ])
    }), ToggleIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ToggleIcon, {
        size: "medium",
        primaryColor: !disabled && isChecked ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)"
    }));
};


const $f25b105f04129604$var$toggleContainerStyles = null;
const $f25b105f04129604$var$i18n = (0, $aXWIB.defineMessages)({
    cardView: {
        id: "page-card.toggle.card-view",
        defaultMessage: "Cards"
    },
    listView: {
        id: "page-card.toggle.list-view",
        defaultMessage: "List"
    },
    compactListView: {
        id: "page-card.toggle.compact-list-view",
        defaultMessage: "Compact list"
    },
    radioGroupLabel: {
        id: "page-card.toggle.radio-group-label",
        defaultMessage: "Appearance"
    }
});
const $f25b105f04129604$export$ff902e0e5a0ce993 = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { appearance: appearance, setAppearance: setAppearance, disabled: disabled, order: t1, source: source } = t0;
    const order = t1 === undefined ? [
        "grid",
        "list"
    ] : t1;
    const filteredOrder = order.filter($f25b105f04129604$var$_temp);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== disabled || $[2] !== setAppearance || $[3] !== source) {
        t2 = (appearance_0)=>{
            if (disabled) return;
            setAppearance(appearance_0);
            const actionSubjectId = appearance_0 === "grid" ? "cards" : "list";
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: source,
                    action: "clicked",
                    actionSubject: "tab",
                    actionSubjectId: actionSubjectId
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = disabled;
        $[2] = setAppearance;
        $[3] = source;
        $[4] = t2;
    } else t2 = $[4];
    const onClick = t2;
    const toggles = {
        grid: {
            id: "grid",
            i18n: $f25b105f04129604$var$i18n.cardView,
            icon: (0, $f1bed3656a6df92d$export$fa17e9a974485717)
        },
        list: {
            id: "list",
            i18n: $f25b105f04129604$var$i18n.listView,
            icon: (0, $781dc60d1c0744fb$export$230671d7ba50d3c8)
        },
        "compact-list": {
            id: "compact-list",
            i18n: $f25b105f04129604$var$i18n.compactListView,
            icon: (0, $892d154fe52aa703$export$f0f500e4832f7ca4)
        },
        "popup-view": null,
        "end-of-page": null,
        "compact-end-of-page": null
    };
    const t3 = "radiogroup";
    let t4;
    if ($[5] !== intl) {
        t4 = intl.formatMessage($f25b105f04129604$var$i18n.radioGroupLabel);
        $[5] = intl;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $gMc0m.default)([
            "_zulp1b66 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c116y _2lx2vrvc _4cvr1h6o _2mzuglyw _1bah1h6o"
        ]);
        $[7] = t5;
    } else t5 = $[7];
    const t6 = filteredOrder.map((t)=>{
        const toggle = toggles[t];
        const ToggleIcon = toggle?.icon;
        return toggle && ToggleIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            key: toggle.id,
            content: intl.formatMessage(toggle.i18n),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
            key: toggle.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $83cf45b7dcdaab8f$export$38dfdd608e2cb4f4), {
            onClick: ()=>onClick(toggle.id),
            isChecked: appearance === toggle.id,
            ToggleIcon: ToggleIcon,
            disabled: disabled,
            label: intl.formatMessage(toggle.i18n)
        })));
    });
    let t7;
    if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
            role: t3,
            "aria-label": t4,
            className: t5
        }, t6);
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
};
const $f25b105f04129604$export$dc05e76bf044b54 = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const defaultAppearance = t0 === undefined ? "grid" : t0;
    const [appearance, setAppearance] = (0, $42omo.useState)(defaultAppearance);
    let t1;
    if ($[0] !== appearance) {
        t1 = {
            appearance: appearance,
            setAppearance: setAppearance
        };
        $[0] = appearance;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
function $f25b105f04129604$var$_temp(view) {
    return view !== "compact-list";
}
module.exports["PageCardAppearanceToggle"] = $f25b105f04129604$export$ff902e0e5a0ce993;

});

parcelRegister("ktNBJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7zgzO = parcelRequire("7zgzO");


var $01STT = parcelRequire("01STT");

const $c653c8ded1552412$export$639584d6e9163827 = ()=>{
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const view = match?.params?.view;
    return Object.values((0, $01STT.View)).includes(view) ? view : (0, $01STT.View).OVERVIEW;
};
module.exports["useSelectedView"] = $c653c8ded1552412$export$639584d6e9163827;

});

parcelRegister("2mfTa", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");


var $ctLrB = parcelRequire("ctLrB");

const $cfb387504b3ebb46$var$getLastActionFromRecent = (recent, isActivityV3HomeRecent)=>{
    const timestamp = isActivityV3HomeRecent ? recent.event?.timestamp || '' : recent.timestamp || '';
    const recentAction = isActivityV3HomeRecent ? recent.event?.eventType : recent.object?.events?.[0].eventType;
    let action;
    switch(recentAction){
        case (0, $ctLrB.ActivityEventType).COMMENTED:
            action = 'commented';
            break;
        case (0, $ctLrB.ActivityEventType).EDITED:
        case (0, $ctLrB.ActivityEventType).UPDATED:
        case (0, $ctLrB.ActivityEventType).PUBLISHED:
        case (0, $ctLrB.ActivityEventType).SNAPSHOTTED:
            action = 'edited';
            break;
        case (0, $ctLrB.ActivityEventType).CREATED:
        case (0, $ctLrB.ActivityEventType).STARTED:
            action = 'createdByYou';
            break;
        case (0, $ctLrB.ActivityEventType).VIEWED:
            action = 'visited';
            break;
        case (0, $ctLrB.ActivityEventType).LIKED:
            action = 'liked';
            break;
    }
    return {
        when: timestamp,
        action: action
    };
};
const $cfb387504b3ebb46$export$b3035d9add269629 = (recent, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false, isActivityV3HomeRecent = false)=>{
    const content = isActivityV3HomeRecent ? recent.object?.data : recent.object?.content;
    return {
        ...(0, $cxMI6.transformGlobalContent)(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        // Using ConfluencePage to fix type error caused by ConfluenceFooterComment not having id in the types file
        key: isActivityV3HomeRecent ? `${content?.id}-${recent?.event?.eventType}` : `${content?.id}-${recent.object?.events?.[0].eventType}`,
        lastAction: $cfb387504b3ebb46$var$getLastActionFromRecent(recent, isActivityV3HomeRecent)
    };
};
const $cfb387504b3ebb46$export$9630855043012801 = (created, untitledDraftText = '', userId = null)=>{
    const id = created?.content?.id || '';
    const content = created?.content;
    const isContentCreatedByCurrentUser = (0, $ctLrB.isCreatorCurrentUser)(userId, content);
    const actionText = !isContentCreatedByCurrentUser ? 'ownedByYou' : 'createdByYou';
    return {
        ...(0, $cxMI6.transformGlobalContent)(content, untitledDraftText),
        key: `${id}-created`,
        lastAction: {
            when: created.content?.metadata.createdDate || '',
            action: actionText
        }
    };
};
const $cfb387504b3ebb46$export$9e542ec8039a0bcd = (draft, untitledDraftText = '')=>{
    const content = draft?.content;
    const id = content?.id || '';
    return {
        ...(0, $cxMI6.transformGlobalContent)(content, untitledDraftText),
        key: `${id}-draft`,
        lastAction: {
            when: content?.metadata.lastModifiedDate || '',
            action: 'edited'
        }
    };
};
const $cfb387504b3ebb46$export$7d474971357ff1a1 = (data, untitledDraftText = '')=>{
    return {
        ...(0, $cxMI6.transformGlobalContent)(data, untitledDraftText),
        lastAction: {
            when: data?.metadata.currentuser?.viewed?.lastSeen || data?.history?.lastUpdated?.when || '',
            action: data?.metadata.currentuser?.viewed?.lastSeen ? 'visited' : 'updated'
        }
    };
};
module.exports["transformRecentToPageCard"] = $cfb387504b3ebb46$export$b3035d9add269629;
module.exports["transformCreatedByMeToPageCard"] = $cfb387504b3ebb46$export$9630855043012801;
module.exports["transformDraftToPageCard"] = $cfb387504b3ebb46$export$9e542ec8039a0bcd;
module.exports["transformStarredToPageCard"] = $cfb387504b3ebb46$export$7d474971357ff1a1;

});

parcelRegister("288YL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $7p4As = parcelRequire("7p4As");


var $dkIiA = parcelRequire("dkIiA");


var $bZSO8 = parcelRequire("bZSO8");

const $c299cfa438844b48$var$i18n = (0, $aXWIB.defineMessages)({
    createPage: {
        id: "home.home-views.create-page",
        defaultMessage: "Create a page"
    },
    createLivePage: {
        id: "home.home-views.create-live-doc",
        defaultMessage: "Create a live doc"
    }
});
const $c299cfa438844b48$export$305e51f590235bd4 = ({ appearance: appearance, creationLinkSource: creationLinkSource, showCreateLivePageButton: showCreateLivePageButton })=>{
    const creationHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        source: creationLinkSource,
        withFallback: true,
        subType: (0, $dkIiA.ConfluencePageSubType).LIVE
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        href: creationHref,
        appearance: appearance,
        shouldFitContainer: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), showCreateLivePageButton ? $c299cfa438844b48$var$i18n.createLivePage : $c299cfa438844b48$var$i18n.createPage));
};
module.exports["CreatePageButton"] = $c299cfa438844b48$export$305e51f590235bd4;

});

parcelRegister("8VNSW", function(module, exports) {
/* Options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4noo5 = parcelRequire("4noo5");


var $jluld = parcelRequire("jluld");


var $inPa6 = parcelRequire("inPa6");


var $6F6hl = parcelRequire("6F6hl");


var $lBLrW = parcelRequire("lBLrW");


var $b3j2Y = parcelRequire("b3j2Y");


var $ktNBJ = parcelRequire("ktNBJ");


var $lXXa4 = parcelRequire("lXXa4");

const $6517be26292f0fb8$var$i18n = (0, $aXWIB.defineMessages)({
    textFilterPlaceholder: {
        id: "home.views.recent.options.placeholder",
        defaultMessage: "Filter by title"
    },
    textFilterDescription: {
        id: "home.views.recent.options.filter.description",
        defaultMessage: "Results will update as you type."
    },
    filteredResultsCount: {
        id: "home.views.recent.filtered-results-announcement",
        defaultMessage: "{count, plural, one {# result} other {# results}} found"
    }
});
const $6517be26292f0fb8$var$optionsContainerStyles = null;
const $6517be26292f0fb8$var$optionsLeftStyles = null;
const $6517be26292f0fb8$export$c019608e5b5bb4cb = ({ appearance: appearance, setAppearance: setAppearance, filterText: filterText, setFilterText: setFilterText, pill: pill, setPill: setPill, pills: pills, loading: loading, queryError: queryError, mutationError: mutationError, pageCardDataLength: pageCardDataLength })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const selectedView = (0, $ktNBJ.useSelectedView)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSearchChange = (0, $42omo.useCallback)((e)=>{
        const text = e.currentTarget.value;
        setFilterText(text);
    }, [
        setFilterText
    ]);
    const onClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${selectedView}Screen`,
                action: 'clicked',
                actionSubject: 'textField',
                actionSubjectId: `${selectedView}ScreenSearchBar`
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        selectedView
    ]);
    const placeholder = formatMessage($6517be26292f0fb8$var$i18n.textFilterPlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _otyrxy5q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        placeholder: placeholder,
        "aria-label": placeholder,
        defaultValue: filterText,
        isCompact: true,
        width: "medium",
        onChange: onSearchChange,
        onClick: onClick,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: "",
            spacing: "spacious"
        }),
        "aria-describedby": "filterByTitleDescription"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        id: "filterByTitleDescription",
        role: "status"
    }, filterText !== '' ? formatMessage($6517be26292f0fb8$var$i18n.filteredResultsCount, {
        count: pageCardDataLength
    }) : formatMessage($6517be26292f0fb8$var$i18n.textFilterDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lXXa4.Pills), {
        pill: pill,
        setPill: setPill,
        pills: pills
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBLrW.PageCardAppearanceToggle), {
        appearance: appearance,
        setAppearance: setAppearance,
        disabled: loading,
        source: `${selectedView}Screen`
    }), queryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError
    }), mutationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: mutationError
    }));
};
module.exports["Options"] = $6517be26292f0fb8$export$c019608e5b5bb4cb;

});

parcelRegister("lXXa4", function(module, exports) {
/* Pills.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $inPa6 = parcelRequire("inPa6");


var $ktNBJ = parcelRequire("ktNBJ");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4342bec3f656d280$var$PillsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bv1ejb _1e0c1txw _4cvr1h6o _u5f3pxbi",
            __cmplp.className
        ])
    });
});
const $4342bec3f656d280$var$PillButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _11c8fhey _1yt4u2gc _2rko1rr0 _vchhusvi _1e0c116y _80omtlke _uiztglyw _o5721q9c _s7n4jp4b _18u0u2gc _4t3izwfg _1bah1h6o _4cvr1h6o _1ul9ckbl _11cpidpf _y2mvdfik _858u1j28",
            __cmplp.isSelected ? "_bfhk15s3" : "_bfhki8nm",
            __cmplp.isSelected ? "_syaz6x5g" : "_syazi7uo",
            __cmplp.isSelected ? "_irr3ufnl" : "_irr3plhp",
            __cmplp.isSelected ? "_19itt0uh" : "_19itbjo2",
            __cmplp.className
        ])
    });
});
const $4342bec3f656d280$export$93f0733b9cd7cb26 = ({ pill: pill, setPill: setPill, pills: pills })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const selectedView = (0, $ktNBJ.useSelectedView)();
    const onClick = (pillButton)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${selectedView}Screen`,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: pillButton.name
            }
        }).fire();
        setPill && setPill(pillButton.name);
    };
    return pills ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4342bec3f656d280$var$PillsContainer, {
        role: "tablist"
    }, pills.map((pillButton)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4342bec3f656d280$var$PillButton // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: "select-task-view",
            key: pillButton.name,
            isSelected: pillButton.name === pill,
            onClick: ()=>onClick(pillButton),
            role: "tab",
            "aria-selected": pillButton.name === pill
        }, pillButton.i18n))) : null;
};
module.exports["Pills"] = $4342bec3f656d280$export$93f0733b9cd7cb26;

});

parcelRegister("92U9l", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");

/**
 * @generated SignedSource<<89563f5bfdcb0a61c66a81d42e25facd>>
 * @relayHash 05bae897240e208934a7314720c18f00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 39afc123c06c997743588fe8d7ca244af12fe910448210de00078d85d933617d
const $01a6c0edea318876$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "appearance"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "homePagesDisplayView",
                            "variableName": "appearance"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "homePagesDisplayView"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "05bae897240e208934a7314720c18f00",
            "id": "39afc123c06c997743588fe8d7ca244af12fe910448210de00078d85d933617d",
            "metadata": {},
            "name": "useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation",
            "operationKind": "mutation",
            "text": "mutation useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation($appearance:PagesDisplayPersistenceOption!){updateUserPreferences(userPreferences:{homePagesDisplayView:$appearance}){homePagesDisplayView}}"
        }
    };
}();
$01a6c0edea318876$var$node.hash = "8413f3eedb4fdf231e9546613d4fa7b8";
var $01a6c0edea318876$export$2e2bcd8739ae039 = $01a6c0edea318876$var$node;


/**
 * @generated SignedSource<<6d69f14dfc235e3e4d6de1797779798f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f4d40ef7fe2ee284$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useHomeViewsUserPreferencesFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "homePagesDisplayView"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "UserPreferences"
};
$f4d40ef7fe2ee284$var$node.hash = "22c9279f3bfbbbd633c516d85ea10c25";
var $f4d40ef7fe2ee284$export$2e2bcd8739ae039 = $f4d40ef7fe2ee284$var$node;



var $igBnm = parcelRequire("igBnm");





var $308Wd = parcelRequire("308Wd");


var $jMyy4 = parcelRequire("jMyy4");


var $ij4CE = parcelRequire("ij4CE");





const $1ace401e96fe65a9$var$useHomeViewsUserPreferencesQuery = (0, $igBnm.default);
const $1ace401e96fe65a9$export$d3291c051e5b508d = (defaultPreference = 'CARDS')=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $f4d40ef7fe2ee284$export$2e2bcd8739ae039),
        fragmentSpec: (0, $f4d40ef7fe2ee284$export$2e2bcd8739ae039),
        __callerPackage__: "@confluence/home"
    });
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($1ace401e96fe65a9$var$useHomeViewsUserPreferencesQuery, {
        skip: !isLoggedIn,
        __callerPackage__: "@confluence/home"
    });
    const appearance = data?.userPreferences?.homePagesDisplayView || defaultPreference;
    const [homeViewsUserPreferencesMutation, { error: mutationError }] = (0, $308Wd.useMutationInterop)((0, $01a6c0edea318876$export$2e2bcd8739ae039), {
        __callerPackage__: "@confluence/home"
    });
    const updateHomeViewsUserPreference = (appearance)=>{
        if (isLoggedIn) {
            homeViewsUserPreferencesMutation({
                variables: {
                    appearance: appearance
                },
                optimisticResponse: {
                    // @ts-ignore __typename does not exist on autogenerated graphql types
                    __typename: 'Mutation',
                    updateUserPreferences: {
                        // @ts-ignore __typename does not exist on autogenerated graphql types
                        __typename: 'UserPreferences',
                        homePagesDisplayView: appearance
                    }
                }
            }).catch(()=>{}); // Ignore the error here since it is handled in useMutation
            // Always write to the cache so the user sees the preference even if there is an error
            // Use writeFragmentInterop instead of writeQuery
            writeFragmentInterop({
                fragmentId: '$ROOT_QUERY.userPreferences',
                data: {
                    homePagesDisplayView: appearance,
                    __typename: 'UserPreferences'
                }
            });
        }
    };
    return {
        loading: loading,
        queryError: queryError,
        mutationError: mutationError,
        appearance: appearance,
        updateHomeViewsUserPreference: updateHomeViewsUserPreference
    };
};
const $1ace401e96fe65a9$export$53a53a6921472be1 = (defaultPreference = 'CARDS')=>{
    const [appearance, setAppearance] = (0, $42omo.useState)(defaultPreference);
    return {
        loading: false,
        appearance: appearance,
        updateHomeViewsUserPreference: setAppearance
    };
};


const $24342ec75a348aae$var$AppearancePersistenceToToggle = {
    CARDS: 'grid',
    LIST: 'list',
    COMPACT_LIST: 'compact-list',
    // Relay adds "%future added value" to all enums for forward compatibility, but it will never actually be used
    '%future added value': 'grid'
};
const $24342ec75a348aae$var$AppearanceToggleToPersistence = {
    grid: 'CARDS',
    list: 'LIST',
    'compact-list': 'COMPACT_LIST',
    'popup-view': 'CARDS',
    'end-of-page': 'CARDS',
    'compact-end-of-page': 'CARDS'
};
const $24342ec75a348aae$export$b8ae39f344200a7d = (pills, defaultPill)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const [filterText, setFilterText] = (0, $42omo.useState)('');
    const [pill, setPill] = (0, $42omo.useState)(defaultPill);
    /**
	 * The default pill will only change if an override from query params changes.
	 * In this case, we need to update the state in order for the UI to reflect
	 * the new pill.
	 */ (0, $42omo.useEffect)(()=>{
        setPill(defaultPill);
    }, [
        defaultPill
    ]);
    const loggedInUserPreferences = (0, $1ace401e96fe65a9$export$d3291c051e5b508d)();
    const anonymousUserPreferences = (0, $1ace401e96fe65a9$export$53a53a6921472be1)();
    const { loading: loading, queryError: queryError, mutationError: mutationError, appearance: appearance, updateHomeViewsUserPreference: updateHomeViewsUserPreference } = isLoggedIn ? loggedInUserPreferences : anonymousUserPreferences;
    const setAppearance = (appearance)=>{
        updateHomeViewsUserPreference($24342ec75a348aae$var$AppearanceToggleToPersistence[appearance]);
    };
    const optionsData = {
        loading: loading,
        queryError: queryError,
        mutationError: mutationError,
        filterText: filterText,
        setFilterText: setFilterText,
        appearance: $24342ec75a348aae$var$AppearancePersistenceToToggle[appearance],
        setAppearance: setAppearance
    };
    if (pills) {
        optionsData.pill = pill;
        optionsData.pill = pill;
        optionsData.setPill = setPill;
        optionsData.pills = pills;
    }
    return optionsData;
};
module.exports["useOptions"] = $24342ec75a348aae$export$b8ae39f344200a7d;

});

parcelRegister("c2B7a", function(module, exports) {
/* LoadingAndPagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $b3j2Y = parcelRequire("b3j2Y");


var $fLinG = parcelRequire("fLinG");


var $ctLrB = parcelRequire("ctLrB");





var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $cO1el = parcelRequire("cO1el");


var $bQm3c = parcelRequire("bQm3c");


var $1NBp8 = parcelRequire("1NBp8");

var $3bef251bc50e9850$exports = {};
$3bef251bc50e9850$exports = new URL("NoResultsImage.ca37f2fe.svg", import.meta.url).toString();


const $2e32c2416bb0a42b$var$NoResultsContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});
const $2e32c2416bb0a42b$export$ef6006467f04ee41 = ({ message: message, subMessage: subMessage, filterText: filterText, source: source, filter: filter })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const fireTrackEvent = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'shown',
                actionSubject: `${source}NoResults`,
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const onSearchClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: `${source}SearchLink`,
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    (0, $42omo.useEffect)(()=>{
        fireTrackEvent();
    }, [
        fireTrackEvent
    ]);
    const hasAdvancedSearchContributorSetting = 'WORKED_ON' === filter;
    const hasAdvancedSearchOwnerSetting = 'CREATED' === filter;
    const searchHref = (0, $1NBp8.ADVANCED_SEARCH).toUrl({}, {
        query: {
            text: filterText,
            ...hasAdvancedSearchContributorSetting && userId && {
                contributors: userId
            },
            ...hasAdvancedSearchOwnerSetting && userId && {
                owners: userId
            }
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2e32c2416bb0a42b$var$NoResultsContainerStyles,
        paddingBlockStart: "space.1000"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3bef251bc50e9850$exports))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlockStart: "space.600",
        paddingBlockEnd: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "small",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), message))), subMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...subMessage,
        values: {
            a: (anchorText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: searchHref,
                    onClick: onSearchClick
                }, anchorText)
        }
    }));
};


/* Empty.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $iXCQx = parcelRequire("iXCQx");


var $gj7hi = parcelRequire("gj7hi");

var $19c42ea63f3ba34c$exports = {};
$19c42ea63f3ba34c$exports = new URL("EmptyStateImageLight.6df2a248.svg", import.meta.url).toString();


const $10e3f67db57b52fe$var$emptyContainerStyles = null;
const $10e3f67db57b52fe$var$emptyHeaderStyles = null;
const $10e3f67db57b52fe$var$emptyBodyStyles = null;
const $10e3f67db57b52fe$var$callToActionStyles = null;
const $10e3f67db57b52fe$var$emptyStateImage = {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($19c42ea63f3ba34c$exports)))
};
const $10e3f67db57b52fe$export$1f74963c34e8bfec = ({ header: header, body: body, image: image = $10e3f67db57b52fe$var$emptyStateImage, callToAction: callToAction })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkxncg _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: image.src,
        srcDark: image.srcDark,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h3", {
        className: (0, $gMc0m.default)([
            "_19pkldb6"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkpxbi _1bsb7ijl _y3gn1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...body,
        values: {
            strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    as: "strong"
                }, chunks)
        }
    })), callToAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkpxbi"
        ])
    }, callToAction));



var $edxGF = parcelRequire("edxGF");

const $0efe97bbc4ecdd1c$var$loadingMoreStyles = null;
const $0efe97bbc4ecdd1c$var$loadingOverlayStyles = null;
const $0efe97bbc4ecdd1c$var$overlaySpinnerContainerStyles = null;
const $0efe97bbc4ecdd1c$export$2a05df71362b48c6 = ({ pageCardDataLength: pageCardDataLength, loading: loading, error: error, hasNextPage: hasNextPage, loadMore: loadMore, noResultsMessage: noResultsMessage, noResultsSubtext: noResultsSubtext, emptyMessageHeader: emptyMessageHeader, emptyMessageBody: emptyMessageBody, emptyMessageImage: emptyMessageImage, emptyMessageCallToAction: emptyMessageCallToAction, filterText: filterText, source: source, filter: filter })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, loading === (0, $ctLrB.LoadingState).done && pageCardDataLength === 0 && !hasNextPage && !error ? filterText !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2e32c2416bb0a42b$export$ef6006467f04ee41), {
        message: noResultsMessage,
        subMessage: noResultsSubtext,
        filterText: filterText,
        source: source,
        filter: filter
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10e3f67db57b52fe$export$1f74963c34e8bfec), {
        header: emptyMessageHeader,
        body: emptyMessageBody,
        image: emptyMessageImage,
        callToAction: emptyMessageCallToAction
    }) : null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $edxGF.Error), null)) : null), loading === (0, $ctLrB.LoadingState).initial && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_lcxvglyw _kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _1e0c1txw _1dth1h6o _4cvr1h6o _nr311h6o _1bah1h6o _tzy4105o"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _154iuuw1 _1ltv1ssb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "large",
        testId: "view-loading"
    }))), hasNextPage && (filterText !== '' || pageCardDataLength !== 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fLinG.ViewportObserver), {
        onViewportEnter: loadMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: {
            position: 'absolute',
            bottom: '0',
            height: '300px'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkxy5q _4t3it9kd _1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "large",
        testId: "page-loading"
    }))));
};
module.exports["LoadingAndPagination"] = $0efe97bbc4ecdd1c$export$2a05df71362b48c6;

});

parcelRegister("2HiJn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ln0hx = parcelRequire("ln0hx");

var $hjygH = parcelRequire("hjygH");


var $ctLrB = parcelRequire("ctLrB");

const $3cb714216690befb$export$4d0d88e71115d042 = ({ experienceName: experienceName, loading: loading, error: error, attributes: attributes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: experienceName
    }), loading === (0, $ctLrB.LoadingState).done && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
        name: experienceName,
        error: error,
        attributes: attributes
    }));
};
module.exports["ExperienceTracking"] = $3cb714216690befb$export$4d0d88e71115d042;

});

parcelRegister("7tW57", function(module, exports) {
var $2151245063608b19$export$fbac647384aa1326 = /*#__PURE__*/ function(QuickActionsEnum) {
    QuickActionsEnum["ShareButton"] = "SHARE";
    QuickActionsEnum["WatchButton"] = "WATCH";
    return QuickActionsEnum;
}({});
module.exports["QuickActionsEnum"] = $2151245063608b19$export$fbac647384aa1326;

});

parcelRegister("fROKr", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $AXitC = parcelRequire("AXitC");

const $a2dbea423c2ae9ef$var$i18n = (0, $aXWIB.defineMessages)({
    unpublished: {
        id: "page-card.lozenge.unpublished",
        defaultMessage: "unpublished changes"
    },
    draft: {
        id: "page-card.lozenge.draft",
        defaultMessage: "draft"
    }
});
const $a2dbea423c2ae9ef$var$columnSpacingStyles = null;
const $a2dbea423c2ae9ef$export$f72db4ad1e9b3e6d = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { isInColumn: isInColumn } = t0;
    const { status: status } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const isValidStatus = status && !!$a2dbea423c2ae9ef$var$i18n[status];
    let t1;
    if ($[0] !== isInColumn || $[1] !== isValidStatus || $[2] !== status) {
        t1 = isValidStatus ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                isInColumn && "_19pkpxbi"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a2dbea423c2ae9ef$var$i18n[status]))) : null;
        $[0] = isInColumn;
        $[1] = isValidStatus;
        $[2] = status;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["StatusLozenge"] = $a2dbea423c2ae9ef$export$f72db4ad1e9b3e6d;

});

parcelRegister("4xawV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b73fd81dd104d571$export$38392c04ead71adc = (0, $42omo.createContext)({
    width: 0
});
module.exports["PageCardsContext"] = $b73fd81dd104d571$export$38392c04ead71adc;

});

parcelRegister("gETnG", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $5xvJl = parcelRequire("5xvJl");


var $AXitC = parcelRequire("AXitC");


var $4xawV = parcelRequire("4xawV");

const $3fc611f28292b239$var$EXCERPT_LINE_HEIGHT = 14;
const $3fc611f28292b239$var$DEFAULT_NUMBER_OF_LINES = 3;
const $3fc611f28292b239$var$styles = {
    container: "_16jlcs5v _1o9zidpf _i0dl1wug _11c8wadc _slp31hna _19pkpxbi",
    text: "_1reo15vq _18m915vq _1e0ccj1k _1yyjcs5v _sudp1e54"
};
const $3fc611f28292b239$export$470ad4730dc14be0 = ()=>{
    const $ = (0, $frIzR.c)(5);
    const { width: width } = (0, $42omo.useContext)((0, $4xawV.PageCardsContext));
    const { id: id, excerpt: excerpt } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const DEFAULT_EXCERPT_HEIGHT = $3fc611f28292b239$var$EXCERPT_LINE_HEIGHT * $3fc611f28292b239$var$DEFAULT_NUMBER_OF_LINES;
    const { ref: outerExcerptRef } = (0, $5xvJl.useHeightRef)(DEFAULT_EXCERPT_HEIGHT);
    let t0;
    if ($[0] !== excerpt || $[1] !== id || $[2] !== outerExcerptRef || $[3] !== width) {
        t0 = excerpt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            key: `${id}-${width}`,
            ref: outerExcerptRef,
            className: (0, $gMc0m.default)([
                $3fc611f28292b239$var$styles.container
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $3fc611f28292b239$var$styles.text
            ])
        }, excerpt)) : null;
        $[0] = excerpt;
        $[1] = id;
        $[2] = outerExcerptRef;
        $[3] = width;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
};
module.exports["Excerpt"] = $3fc611f28292b239$export$470ad4730dc14be0;

});

parcelRegister("5xvJl", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $0dca7ed22d181ab5$export$5b067724590b37a4 = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const defaultHeight = t0 === undefined ? 0 : t0;
    const [height, setHeight] = (0, $42omo.useState)(defaultHeight);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (node)=>{
            node && setHeight(node.clientHeight);
        };
        $[0] = t1;
    } else t1 = $[0];
    const ref = t1;
    let t2;
    if ($[1] !== height) {
        t2 = {
            height: height,
            ref: ref
        };
        $[1] = height;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
module.exports["useHeightRef"] = $0dca7ed22d181ab5$export$5b067724590b37a4;

});


$parcel$global.rlb("c2iR7")
//# sourceMappingURL=EndOfPageRecommendation.e5aacc95.js.map
